/*
 * Nordbjærg's katalog (sections/nb-katalog.liquid, snippets/nb-katalog-shell.liquid).
 * The webshop as a book: a cover, a table of contents and the chapters set up in the theme editor. A
 * chapter is one collection, or several sections (underkapitler) that are each a collection. Inside a
 * section the products are sorted by brand, then by name, with a brand band where the brand changes.
 * Two pages side by side on wide screens, one page on phones; a page turns over like paper (a plain
 * swap with reduced motion). Tapping a product opens a popup with photos, variants, quantity and
 * "Læg i kurv". Prices and stock come live from the webshop (templates/collection.katalogdata.liquid,
 * 250 products per request, loaded one section at a time when it is opened).
 *
 * window.NBKatalog.mount(root, config) starts a book; the catalogue page mounts itself, the popup on
 * collection pages mounts on demand (sections/main-collection.liquid).
 */
(function () {
  'use strict';
  if (window.NBKatalog) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var money = new Intl.NumberFormat('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Heights and widths in px of the parts of a chapter page. assets/nb-katalog.css draws them at exactly
  // these sizes, so the script can fill a page without measuring it.
  var L = { band: 34, partHead: 50, pad: 17, head: 64, headSingle: 72, gap: 4, thead: 18, row: 24, more: 24, maxRows: 6, colGap: 20, colMin: 240 };

  function formatPrice(ore) { return money.format((ore || 0) / 100) + ' kr'; }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function plural(n, one, many) { return n === 1 ? one : many; }
  function fmtInt(n) { return Math.round(n).toLocaleString('da-DK'); }

  // Remove anything active from a product description before it is shown
  function cleanHtml(html) {
    var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    doc.querySelectorAll('script,style,iframe,object,embed,form,link,meta').forEach(function (n) { n.remove(); });
    doc.querySelectorAll('*').forEach(function (n) {
      Array.prototype.slice.call(n.attributes).forEach(function (a) {
        if (/^on/i.test(a.name) || (a.name === 'href' && /^\s*javascript:/i.test(a.value)) || a.name === 'style') n.removeAttribute(a.name);
      });
    });
    return doc.body.firstChild.innerHTML;
  }

  function Book(root, config) {
    this.root = root;
    this.cfg = config;
    this.ui = root.querySelector('[data-nbk]');
    this.stage = root.querySelector('[data-nbk-stage]');
    this.book = root.querySelector('[data-nbk-book]');
    this.slotL = root.querySelector('[data-nbk-left]');
    this.slotR = root.querySelector('[data-nbk-right]');
    this.label = root.querySelector('[data-nbk-label]');
    this.live = root.querySelector('[data-nbk-live]');
    this.dialog = root.querySelector('[data-nbk-dialog]');
    this.dialogBody = root.querySelector('[data-nbk-dialog-body]');
    this.toc = root.querySelector('[data-nbk-toc]');
    this.toast = root.querySelector('[data-nbk-toast]');
    this.rail = root.querySelector('[data-nbk-rail]');
    this.inOverlay = !!config.overlay;
    this.front = config.frontMatter !== false; // cover and contents (left out in the popup on collection pages)
    // Long variant lists: the first few rows and "Vis alle" that unfolds the rest (theme editor setting),
    // or up to L.maxRows rows and "+ n mere" that opens the product
    this.collapse = config.collapse !== false;
    // "Vis udsolgte" in the toolbar; the theme editor setting is where it starts
    this.showSoldOut = !!config.showSoldOut;
    this.variantRows = Math.max(1, Math.min(L.maxRows, parseInt(config.variantRows, 10) || 3));
    // The reader's own zoom (the slider in the toolbar), kept in this browser only
    this.userZoom = 1;
    try { this.userZoom = Math.max(0.8, Math.min(1.6, parseFloat(localStorage.getItem('nbk-zoom')) || 1)); } catch (e) {}
    this.other = (config.otherBrands || '').split(/\r?\n/).map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    // Chapters (groups) hold one or more sections (parts), each a collection loaded on its own. A chapter
    // without sections in the theme editor is its own single section.
    var book = this;
    this.groups = [];
    this.chapters = []; // every section, in reading order
    (config.chapters || []).forEach(function (c) {
      var parts = (c.parts || []).filter(function (p) { return p && p.url; });
      if (!parts.length && c.url) parts = [{ id: c.id, title: c.title, handle: c.handle, url: c.url, count: c.count }];
      if (!parts.length) return;
      var g = { idx: book.groups.length, id: c.id, title: c.title, url: c.url || null, intro: c.intro || '', picto: c.picto || 'sejlbaad', dept: c.dept || '', deptPicto: c.deptPicto || '', parts: [] };
      parts.forEach(function (p) {
        var part = { idx: book.chapters.length, group: g, single: parts.length === 1, id: p.id, title: p.title || c.title, handle: p.handle, url: p.url, count: p.count || 0, picto: g.picto, items: null, loading: null, progress: 0, pages: null };
        g.parts.push(part);
        book.chapters.push(part);
      });
      book.groups.push(g);
    });
    // Groups of chapters (the menu's first level, "dept"): with two or more, the tabs fold in two (the
    // groups, and under the one being read its chapters) and the contents page lists the groups
    this.depts = [];
    this.groups.forEach(function (g) {
      var d = book.depts[book.depts.length - 1];
      if (!d || d.title !== g.dept) {
        d = { idx: book.depts.length, title: g.dept, picto: g.deptPicto || g.picto, groups: [] };
        book.depts.push(d);
      }
      g.deptRef = d;
      d.groups.push(g);
    });
    if (this.depts.length < 2 || this.depts.some(function (d) { return !d.title; })) this.depts = null;
    this.cur = 0;          // index of the first page shown (0 = cover)
    this.anchor = null;    // {chapter, item} to keep the place when pages are re-laid out
    this.animating = null;
    this.measure();
    this.buildRail();
    this.bind();
    var start = this.pageFromHash();
    this.go(start != null ? start : 0, { instant: true });
    // The first chapter starts loading while the cover is read
    if (this.chapters.length) this.load(this.chapters[0]);
  }

  Book.prototype.picto = function (name) {
    var t = this.root.querySelector('template[data-nbk-picto="' + name + '"]') || document.querySelector('template[data-nbk-picto="' + name + '"]');
    return t ? t.innerHTML : '';
  };

  /* ---------- Geometry ---------- */
  Book.prototype.measure = function () {
    // On the catalogue page the book fills the rest of the first screen (CSS: 100svh minus this)
    if (!this.inOverlay) this.ui.style.setProperty('--nbk-top', Math.round(this.ui.getBoundingClientRect().top + window.scrollY) + 'px');
    var r = this.stage.getBoundingClientRect(), cs = getComputedStyle(this.stage);
    var w = Math.max(280, r.width), h = Math.max(360, r.height - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom));
    var spread = w >= 900 && h >= 480;
    var edges = spread ? 112 : (w < 600 ? 0 : 96);
    var pageW, pageH;
    if (spread) {
      pageW = Math.min((w - edges) / 2, h * 0.8);
    } else {
      pageW = Math.min(w - edges - (w < 600 ? 16 : 0), h * 0.8, 560);
    }
    pageH = Math.min(h, pageW / 0.8);
    if (!spread && w < 600) pageH = h; // phones: the page uses the full height
    this.mode = spread ? 'spread' : 'single';
    // Phones: taller rows and bigger buttons for fingers (assets/nb-katalog.css, max-width 640px)
    var phone = window.matchMedia('(max-width: 640px)').matches;
    this.L = phone ? Object.assign({}, L, { row: 30, more: 30, thead: 20, headSingle: 78 }) : L;
    var q = this.root.querySelector('.nbk-search__input');
    if (q) q.placeholder = phone ? 'Søg' : 'Søg i kataloget';
    // The filters: in the toolbar, or on phones (no room there) at the top of the Oversigt panel
    var filters = this.root.querySelector('[data-nbk-filters]');
    if (filters) {
      if (phone && filters.parentNode !== this.toc) this.toc.prepend(filters);
      else if (!phone && filters.parentNode === this.toc) {
        var after = this.root.querySelector('.nbk-search');
        after.parentNode.insertBefore(filters, after.nextSibling);
      }
    }
    this.pageW = Math.floor(pageW);
    this.pageH = Math.floor(pageH);
    // Zoom: the page content grows with the page on big screens, times the reader's own zoom. The content
    // is drawn with CSS zoom, so it has (page size / zoom) of room.
    this.zoom = phone ? 1 : Math.max(1, Math.min(1.5, this.pageH / 680)) * this.userZoom;
    // Page content: padding, running head and footer take 112px of the height; padding (and on phones the
    // chapter strip) the sides. At most two columns.
    this.contentH = (this.pageH - 112) / this.zoom;
    var contentW = (this.pageW - (phone ? 34 : 36)) / this.zoom;
    this.cols = Math.max(1, Math.min(2, Math.floor((contentW + L.colGap) / (L.colMin + L.colGap))));
    // The compact one-variant entry (number, price and + beside the photo) needs a column of 300px
    this.compactSingle = (contentW - (this.cols - 1) * L.colGap) / this.cols >= 300;
    // On the stage, so the edge buttons beside the book can use the page size too
    this.stage.style.setProperty('--nbk-page-w', this.pageW + 'px');
    this.stage.style.setProperty('--nbk-page-h', this.pageH + 'px');
    this.stage.style.setProperty('--nbk-cols', this.cols);
    this.stage.style.setProperty('--nbk-zoom', this.zoom);
    var zl = this.root.querySelector('[data-nbk-zoom-value]');
    if (zl) zl.textContent = Math.round(this.userZoom * 100) + ' %';
    this.book.classList.toggle('nbk-book--spread', spread);
    this.book.classList.toggle('nbk-book--single', !spread);
    this.chapters.forEach(function (c) { c.pages = null; });
  };

  /* ---------- Data ---------- */
  Book.prototype.load = function (ch) {
    if (ch.items || ch.loading) return ch.loading;
    var self = this;
    var url = function (page) { return ch.url + (ch.url.indexOf('?') > -1 ? '&' : '?') + 'view=' + (self.cfg.dataView || 'katalogdata') + '&page=' + page; };
    var all = [];
    function fetchPage(page) {
      return fetch(url(page), { credentials: 'same-origin' }).then(function (r) {
        if (r.status === 429) return new Promise(function (res) { setTimeout(res, 2500); }).then(function () { return fetchPage(page); });
        return r.text();
      }).then(function (text) {
        if (typeof text !== 'string') return text;
        var a = text.indexOf('/*NBKATALOG*/'), b = text.lastIndexOf('/*NBKATALOG*/');
        if (a < 0 || b <= a) throw new Error('no data');
        return JSON.parse(text.slice(a + 13, b));
      });
    }
    ch.loading = fetchPage(1).then(function (first) {
      all = all.concat(first.products);
      ch.count = first.count || ch.count;
      var total = first.pages || 1, next = 2, done = 1;
      ch.progress = done / total;
      self.refreshIfShowing(ch);
      function worker() {
        if (next > total) return Promise.resolve();
        var p = next++;
        return fetchPage(p).then(function (d) {
          all = all.concat(d.products);
          done++;
          ch.progress = done / total;
          self.refreshIfShowing(ch, true);
          return worker();
        });
      }
      return Promise.all([worker(), worker()]);
    }).then(function () {
      ch.raw = all;
      ch.items = self.prepare(all);
      ch.pages = null;
      ch.loading = null;
      self.relayout(ch);
    }).catch(function () {
      ch.loading = null;
      ch.failed = true;
      self.refreshIfShowing(ch);
    });
    return ch.loading;
  };

  // Sorted by brand, then name. Every product keeps its place number (ord) in the full list, so the
  // reader's place survives the "Kun på hylden" filter.
  // The place number is counted over every product of the section, sold out or not, before either filter
  // (owner, 31 Oct 2026: turning "Vis udsolgte" on or off moved the reader to another brand, because the
  // numbers were counted after sold-out products were taken out). With one numbering for all filter
  // settings, relayout() finds the same product, or the place where it would stand: the same brand, or
  // the nearest one that is left.
  Book.prototype.prepare = function (list) {
    var self = this, seen = {}, showSoldOut = this.showSoldOut;
    var items = list.filter(function (p) {
      if (seen[p.h]) return false;
      seen[p.h] = true;
      return true;
    });
    items.forEach(function (p) {
      // No vendor, or the placeholder "None" from the product feed, also goes under the shared heading
      var isOther = !p.b || /^none$/i.test(p.b) || self.other.indexOf(String(p.b).toLowerCase()) > -1;
      p.brand = isOther ? self.cfg.otherLabel : p.b;
      p.other = isOther;
      p.vsShown = (p.vs || []).filter(function (v) { return showSoldOut || v.a; });
      // Thumbnails in the rows only when the variants have photos of their own
      var imgs = {};
      p.vsShown.forEach(function (v) { if (v.i) imgs[v.i.split('?')[0]] = 1; });
      p.thumbs = Object.keys(imgs).length > 1;
    });
    var coll = new Intl.Collator('da', { sensitivity: 'base', numeric: true });
    items.sort(function (x, y) {
      if (x.other !== y.other) return x.other ? 1 : -1;
      return coll.compare(x.brand, y.brand) || coll.compare(x.t, y.t);
    });
    items.forEach(function (p, i) { p.ord = i; });
    if (!showSoldOut) items = items.filter(function (p) { return p.a; });
    if (this.shelfOnly) items = items.filter(function (p) { return p.sh; });
    return items;
  };

  // How tall an entry is in the given space: photo and name, then a row per variant (at most L.maxRows)
  // and "+ n mere". Where the space is short it shows fewer rows. Returns false if it does not fit.
  Book.prototype.entryLayout = function (item, space) {
    var LL = this.L;
    var rows = this.shelfOnly ? item.vsShown.filter(function (v) { return v.sh; }) : item.vsShown;
    var multi = item.n > 1;
    var total = this.shelfOnly ? rows.length : Math.max(this.showSoldOut ? item.n : (item.na || 0), rows.length);
    var base = LL.pad + LL.head + LL.gap + (multi ? LL.thead : 0);
    var cap = Math.min(rows.length, this.collapse ? this.variantRows : LL.maxRows);
    var shown = cap;
    if (base + cap * LL.row + (total > cap ? LL.more : 0) > space) {
      shown = Math.max(0, Math.min(cap, Math.floor((space - base - LL.more) / LL.row)));
    }
    var more = total - shown;
    if (shown === 0 && more < 1) more = 1;
    item.multi = multi;
    item.rows = rows.slice(0, shown);
    item.more = more;
    // One variant: item number, price and the basket button sit beside the photo, under the name
    item.single = this.compactSingle && !multi && shown === 1 && more <= 0;
    item.ht = item.single ? LL.pad + LL.headSingle : base + shown * LL.row + (more > 0 ? LL.more : 0);
    // Folding on: one row and "Vis alle" is enough; off: at least two rows before "+ n mere"
    return item.ht <= space && shown >= Math.min(this.collapse ? 1 : 2, cap);
  };

  /* ---------- Pagination ---------- */
  // A section is product pages. A page has one or two columns that fill from the top; a brand band starts
  // every column and every new brand. In a chapter with several sections, each section starts on a new
  // page under its own heading.
  Book.prototype.paginate = function (ch) {
    var LL = this.L;
    if (ch.pages) return ch.pages;
    var H = this.contentH, C = this.cols;
    var headH = ch.single ? 0 : LL.partHead;
    if (!ch.items) {
      var perCol = Math.max(1, Math.floor((H - LL.band) / (LL.pad + LL.head + LL.gap + LL.row * 1.8)));
      var est = Math.max(1, Math.ceil((ch.count || 0) / (perCol * C) * 1.05));
      ch.pages = { estimated: true, length: est, list: null };
      return ch.pages;
    }
    var pages = [], page = null, col = null, used = 0, cap = H, lastBrand = null, self = this;
    function newColumn(brand, cont) {
      if (!page || page.cols.length === C) {
        page = { kind: 'items', cols: [], firstItem: null, head: !pages.length && headH > 0 };
        pages.push(page);
        cap = H - (page.head ? headH : 0);
      }
      col = [];
      page.cols.push(col);
      col.push({ band: brand, cont: cont });
      used = LL.band;
    }
    ch.items.forEach(function (item, i) {
      var change = item.brand !== lastBrand;
      if (!col) {
        newColumn(item.brand, false);
        self.entryLayout(item, cap - used);
      } else if (!self.entryLayout(item, cap - used - (change ? LL.band : 0))) {
        newColumn(item.brand, !change);
        self.entryLayout(item, cap - used);
      } else if (change) {
        col.push({ band: item.brand });
        used += LL.band;
      }
      col.push({ item: i });
      used += item.ht;
      if (page.firstItem == null) page.firstItem = i;
      lastBrand = item.brand;
    });
    // Nothing to show (e.g. nothing on the shelf): one page that says so
    if (!pages.length) pages.push({ kind: 'empty', cols: [], firstItem: null, head: headH > 0 });
    // Brands and the page (within the section) where each starts
    var brands = [], byName = {};
    pages.forEach(function (p, pi) {
      p.cols.forEach(function (c) {
        c.forEach(function (b) {
          if (b.band && !b.cont && !byName[b.band]) { byName[b.band] = { name: b.band, page: pi, count: 0 }; brands.push(byName[b.band]); }
        });
      });
    });
    ch.items.forEach(function (it) { if (byName[it.brand]) byName[it.brand].count++; });
    ch.brands = brands;
    ch.pages = { estimated: false, length: pages.length, list: pages };
    return ch.pages;
  };


  // Front matter: cover (0) and contents (1). Then per chapter its opening page and its sections' pages.
  Book.prototype.offsets = function () {
    var n = this.front ? 2 : 0, exact = true, self = this, gs = [], ps = [], approx = [];
    this.groups.forEach(function (g) {
      approx[g.idx] = !exact;
      gs.push(n);
      n += 1;
      g.parts.forEach(function (p) {
        ps[p.idx] = n;
        var pg = self.paginate(p);
        if (pg.estimated) exact = false;
        n += pg.length;
      });
    });
    return { groups: gs, parts: ps, approx: approx, total: n, exact: exact };
  };


  Book.prototype.locate = function (index) {
    if (this.front && index <= 0) return { kind: 'cover' };
    if (this.front && index === 1) return { kind: 'toc' };
    var o = this.offsets();
    if (index >= o.total) return { kind: 'blank' };
    for (var g = this.groups.length - 1; g >= 0; g--) {
      if (index < o.groups[g]) continue;
      var grp = this.groups[g];
      if (index === o.groups[g]) return { kind: 'opener', group: grp };
      for (var k = grp.parts.length - 1; k >= 0; k--) {
        var p = grp.parts[k];
        if (index >= o.parts[p.idx]) return { kind: 'part', group: grp, chapter: p, local: index - o.parts[p.idx] };
      }
    }
    return { kind: 'blank' };
  };


  Book.prototype.total = function () { return this.offsets().total; };

  /* ---------- Rendering ---------- */
  Book.prototype.renderPage = function (index) {
    var total = this.total();
    if (index === -1 && this.front && this.mode === 'spread') return this.renderGuidePage();
    if (index < 0 || index >= total) { var b = el('div', 'nbk-page nbk-page--blank'); b.setAttribute('aria-hidden', 'true'); return b; }
    var where = this.locate(index);
    var page = el('div', 'nbk-page');
    page.dataset.index = index;
    var side = this.mode === 'spread' ? (index % 2 === 0 ? 'right' : 'left') : 'right';
    if (index === 0) side = 'right';
    page.classList.add('nbk-page--' + side);
    if (where.kind === 'cover') return this.renderCover(page);
    if (where.kind === 'toc') return this.renderToc(page, index);
    if (where.kind === 'blank') { page.classList.add('nbk-page--blank'); return page; }
    var grp = where.group, ch = where.chapter;
    page.classList.add('nbk-page--chapter');
    // Chapter strip on the outer edge (phones; each chapter a step lower), running head and footer
    page.style.setProperty('--nbk-tab', this.groups.length > 1 ? grp.idx / (this.groups.length - 1) : 0);
    var tab = el('div', 'nbk-tab');
    tab.innerHTML = this.picto(grp.picto);
    tab.appendChild(el('span', 'nbk-tab__label', grp.title));
    page.appendChild(tab);
    var head = el('div', 'nbk-head');
    head.appendChild(el('span', 'nbk-head__chapter', grp.title + (ch && !ch.single ? ' · ' + ch.title : '')));
    page.appendChild(head);
    var body = el('div', 'nbk-body');
    page.appendChild(body);
    var foot = el('div', 'nbk-foot');
    foot.appendChild(el('span', 'nbk-foot__no', String(index + 1)));
    foot.appendChild(el('span', 'nbk-foot__legend', 'På hylden i butikken'));
    if (this.cfg.footer && where.kind === 'opener') foot.appendChild(el('span', 'nbk-foot__note', this.cfg.footer));
    page.appendChild(foot);

    if (where.kind === 'opener') { this.renderOpener(body, grp); return page; }
    var pg = this.paginate(ch);
    if (pg.estimated || !pg.list) {
      body.classList.add('nbk-body--loading');
      var msg = el('div', 'nbk-loading');
      if (ch.failed) {
        msg.appendChild(el('p', null, (ch.single ? 'Kapitlet' : 'Afsnittet') + ' kunne ikke hentes.'));
        var retry = el('button', 'nbk-btn nbk-btn--ghost', 'Prøv igen');
        retry.type = 'button';
        var self = this;
        retry.addEventListener('click', function () { ch.failed = false; self.load(ch); self.show(true); });
        msg.appendChild(retry);
      } else {
        msg.appendChild(el('p', null, 'Henter ' + (ch.single ? '' : ch.title + ': ') + fmtInt(ch.count) + ' varer …'));
        var bar = el('div', 'nbk-progress');
        var fill = el('span');
        fill.style.transform = 'scaleX(' + (ch.progress || 0.04) + ')';
        bar.appendChild(fill);
        msg.appendChild(bar);
        this.load(ch);
      }
      body.appendChild(msg);
      return page;
    }
    var spec = pg.list[where.local];
    if (!spec) return page;
    var self2 = this;
    body.classList.add('nbk-body--cols');
    if (spec.head) body.appendChild(this.renderPartHead(ch));
    if (spec.kind === 'empty') {
      body.appendChild(el('p', 'nbk-empty', this.shelfOnly ? 'Intet på hylden i butikken her.' : 'Ingen varer her.'));
      return page;
    }
    spec.cols.forEach(function (c) {
      var colEl = el('div', 'nbk-col');
      c.forEach(function (b) {
        if (b.band) {
          var band = el('div', 'nbk-band');
          band.appendChild(el('span', 'nbk-band__name', b.band));
          if (b.cont) band.appendChild(el('span', 'nbk-band__cont', 'fortsat'));
          colEl.appendChild(band);
        } else {
          colEl.appendChild(self2.renderEntry(ch.items[b.item]));
        }
      });
      body.appendChild(colEl);
    });
    return page;
  };

  // The heading on a section's first page: the chapter small, the section large (L.partHead tall)
  Book.prototype.renderPartHead = function (ch) {
    var h = el('div', 'nbk-parthead');
    h.appendChild(el('span', 'nbk-parthead__eyebrow', ch.group.title));
    var t = el('span', 'nbk-parthead__title', ch.title);
    h.appendChild(t);
    if (ch.items) h.appendChild(el('span', 'nbk-parthead__count', fmtInt(ch.items.length) + ' varer'));
    return h;
  };


  Book.prototype.renderCover = function (page) {
    page.classList.add('nbk-page--cover');
    var logo = document.querySelector('.header__logo-image');
    var inner = el('div', 'nbk-cover');
    if (logo) {
      var l = logo.cloneNode(true);
      l.removeAttribute('width'); l.removeAttribute('height');
      l.className = 'nbk-cover__logo';
      l.setAttribute('alt', "Nordbjærg's");
      inner.appendChild(l);
    }
    inner.appendChild(el('p', 'nbk-cover__title', this.cfg.title || "Nordbjærg's katalog"));
    if (this.cfg.subtitle) inner.appendChild(el('p', 'nbk-cover__subtitle', this.cfg.subtitle));
    if (this.cfg.cover) {
      var img = el('img', 'nbk-cover__image');
      img.src = this.cfg.cover; img.alt = this.cfg.coverAlt || ''; img.loading = 'eager';
      inner.appendChild(img);
    }
    if (this.cfg.intro) inner.appendChild(el('p', 'nbk-cover__intro', this.cfg.intro));
    var total = this.chapters.reduce(function (s, c) { return s + (c.count || 0); }, 0);
    if (total) inner.appendChild(el('p', 'nbk-cover__count', fmtInt(total) + ' varer i ' + this.groups.length + ' ' + plural(this.groups.length, 'kapitel', 'kapitler')));
    var open = el('button', 'nbk-btn nbk-btn--light', 'Bladr i kataloget →');
    open.type = 'button';
    var self = this;
    open.addEventListener('click', function () { self.next(); });
    inner.appendChild(open);
    if (this.mode !== 'spread') inner.appendChild(this.guide(true));
    page.appendChild(inner);
    return page;
  };

  /* ---------- "Sådan bruger du kataloget" (owner, 25 Oct 2026) ----------
     In a spread the page left of the cover was empty: it now holds a short guide that folds out from
     a button – what the catalogue is, how to turn pages and find things, the filters, and buying from
     the rows. On a single page it folds out under the cover's button instead. The text follows where
     the tools are on this screen (upright bar from 1000px, a line above the book, Oversigt on phones). */
  var guideCount = 0;
  var GUIDE_ICONS = {
    arrows: '<path d="M7.5 5 3 10l4.5 5M12.5 5 17 10l-4.5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    tabs: '<path d="M6 3h8v4H6zM6 9h8v4H6zM6 15h8v2H6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',
    toc: '<path d="M3 4h4v4H3zM9 5h8M3 12h4v4H3zM9 13h8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
    search: '<circle cx="8.5" cy="8.5" r="5.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M13 13l4.5 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
    toggle: '<rect x="2" y="6" width="16" height="8" rx="4" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="13.5" cy="10" r="2.2" fill="currentColor"/>',
    zoom: '<circle cx="8.5" cy="8.5" r="5.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M13 13l4.5 4.5M6 8.5h5M8.5 6v5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
    cart: '<path d="M2 3h2.2l1.9 9.2a1.5 1.5 0 0 0 1.5 1.2h6.9a1.5 1.5 0 0 0 1.5-1.1L17.5 7H5.3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="17" r="1.3" fill="currentColor"/><circle cx="14.5" cy="17" r="1.3" fill="currentColor"/>',
    photo: '<rect x="2.5" y="4" width="15" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M5 13.5l3.5-4 3 3 2-2 2.5 3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
    dot: '<circle cx="10" cy="10" r="4.5" class="nbk-guide__dot"/>'
  };

  Book.prototype.guide = function (onDark) {
    var self = this;
    var spread = this.mode === 'spread';
    var phone = window.matchMedia('(max-width: 640px)').matches;
    var upright = window.matchMedia('(min-width: 1000px)').matches;
    var id = 'nbk-guide-' + (++guideCount);
    var wrap = el('div', 'nbk-guide' + (onDark ? ' nbk-guide--dark' : '') + (this.guideOpen ? ' is-open' : ''));

    var btn = el('button', 'nbk-guide__toggle');
    btn.type = 'button';
    btn.setAttribute('aria-expanded', this.guideOpen ? 'true' : 'false');
    btn.setAttribute('aria-controls', id);
    btn.innerHTML = '<span class="nbk-guide__toggle-text">Sådan bruger du kataloget</span>' +
      '<svg class="nbk-guide__chev" viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M5 7.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    wrap.appendChild(btn);
    if (!onDark) wrap.appendChild(el('p', 'nbk-guide__teaser', 'Hvad kataloget er, og hvordan du bladrer, søger og filtrerer.'));

    var panel = el('div', 'nbk-guide__panel');
    panel.id = id;
    var inner = el('div', 'nbk-guide__inner');
    function section(title, rows) {
      var sec = el('div', 'nbk-guide__sec');
      sec.appendChild(el('p', 'nbk-guide__h', title));
      var ul = el('ul', 'nbk-guide__list');
      rows.forEach(function (r) {
        if (!r) return;
        var li = el('li', 'nbk-guide__row');
        var ic = el('span', 'nbk-guide__ic');
        ic.innerHTML = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">' + GUIDE_ICONS[r[0]] + '</svg>';
        li.appendChild(ic);
        var t = el('span', 'nbk-guide__t');
        t.innerHTML = r[1];
        li.appendChild(t);
        ul.appendChild(li);
      });
      sec.appendChild(ul);
      return sec;
    }

    var total = this.chapters.reduce(function (s, c) { return s + (c.count || 0); }, 0);
    var n = this.groups.length;
    var what = el('p', 'nbk-guide__lede');
    what.textContent = (total ? 'Alle ' + fmtInt(total) + ' varer fra webshoppen, samlet i ' + n + ' ' + plural(n, 'kapitel', 'kapitler') + ' som i et trykt katalog. '
      : 'Varerne fra webshoppen, samlet i kapitler som i et trykt katalog. ') +
      'I hvert kapitel står varerne efter mærke og navn. Priser og lager kommer direkte fra webshoppen, så det, du ser, kan du købe.';
    inner.appendChild(what);

    var where = upright ? 'i bjælken til venstre for bogen' : (phone ? 'øverst i Oversigt' : 'i linjen over bogen');
    inner.appendChild(section('Bladr og find rundt', [
      spread ? ['arrows', 'Bladr med pilene ved siden af bogen eller med piletasterne.']
        : (phone ? ['arrows', 'Stryg til siden, eller brug pilene nederst.'] : ['arrows', 'Bladr med pilene ved siden af bogen eller nederst.']),
      spread ? ['tabs', 'Fanerne ved bogens højre kant går til et kapitel. Peg på en fane for at se underkapitler og mærker.'] : null,
      ['toc', '<b>Oversigt</b> viser kapitler, underkapitler og mærker med sidetal. Tryk for at gå derhen.'],
      ['search', '<b>Søg</b> finder en vare, og bogen slår op på siden, hvor den står.']
    ]));
    inner.appendChild(section('Filtrer', [
      ['toggle', '<b>Kun på hylden</b> viser kun varer, der står på hylden i butikken på Skovshoved Havn.'],
      ['toggle', '<b>Vis udsolgte</b> tager udsolgte varer med.'],
      phone ? ['zoom', 'Du finder filtrene ' + where + '. Zoom med to fingre.']
        : ['zoom', '<b>Zoom</b> gør siderne større, og <b>Fuld skærm</b> giver bogen hele skærmen. Du finder det hele ' + where + '.']
    ]));
    inner.appendChild(section('Køb fra kataloget', [
      ['cart', 'Den lille kurv-knap i en række lægger netop den variant i kurven.'],
      ['photo', 'Tryk på et foto eller et navn for at se hele varen.'],
      ['dot', 'Grøn prik: varianten står på hylden i butikken.']
    ]));
    panel.appendChild(inner);
    wrap.appendChild(panel);

    // The page scrolls when the guide is longer than the page: the text fades out at the bottom while
    // there is more below, so it doesn't look cut off
    function fade() {
      var box = wrap.closest('.nbk-body--guide, .nbk-cover');
      if (box) box.classList.toggle('nbk-fade-end', box.scrollHeight - box.clientHeight - box.scrollTop > 4);
    }
    function watch() {
      var box = wrap.closest('.nbk-body--guide, .nbk-cover');
      if (!box || box.__nbkFade) return;
      box.__nbkFade = true;
      box.addEventListener('scroll', fade, { passive: true });
    }
    btn.addEventListener('click', function () {
      self.guideOpen = !self.guideOpen;
      wrap.classList.toggle('is-open', self.guideOpen);
      btn.setAttribute('aria-expanded', self.guideOpen ? 'true' : 'false');
      watch();
      setTimeout(fade, 260);
      // On the cover the guide sits under the button: bring it into view inside the page
      if (onDark && self.guideOpen) {
        setTimeout(function () {
          var box = wrap.closest('.nbk-cover');
          if (!box || box.scrollHeight <= box.clientHeight) return;
          var top = wrap.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop - 8;
          box.scrollTo({ top: top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }, 60);
      }
    });
    if (this.guideOpen) requestAnimationFrame(function () { watch(); fade(); });
    return wrap;
  };

  Book.prototype.renderGuidePage = function () {
    var page = el('div', 'nbk-page nbk-page--left nbk-page--guide');
    var body = el('div', 'nbk-body nbk-body--guide');
    body.appendChild(el('p', 'nbk-guide__eyebrow', 'Før du bladrer'));
    body.appendChild(this.guide(false));
    page.appendChild(body);
    return page;
  };

  Book.prototype.renderToc = function (page, index) {
    page.classList.add('nbk-page--toc');
    var body = el('div', 'nbk-body nbk-body--toc');
    body.appendChild(el('p', 'nbk-toc-page__eyebrow', 'Indhold'));
    body.appendChild(el('p', 'nbk-toc-page__title', 'Kapitler'));
    var o = this.offsets(), self = this;
    var list = el('ol', 'nbk-toc-page__list');
    // Grouped: each group as a row with its chapters under it (their sections are on the chapters' own
    // first pages and in the tabs' flyouts)
    if (this.depts) {
      this.depts.forEach(function (d) {
        var first = d.groups[0];
        var li = el('li');
        var a = el('button', 'nbk-toc-page__item');
        a.type = 'button';
        var ic = el('span', 'nbk-toc-page__picto'); ic.innerHTML = self.picto(d.picto);
        a.appendChild(ic);
        var txt = el('span', 'nbk-toc-page__text');
        txt.appendChild(el('span', 'nbk-toc-page__name', d.title));
        txt.appendChild(el('span', 'nbk-toc-page__count', fmtInt(self.deptCount(d)) + ' varer · ' + d.groups.length + ' ' + plural(d.groups.length, 'kapitel', 'kapitler')));
        a.appendChild(txt);
        a.appendChild(el('span', 'nbk-toc-page__no', (o.approx[first.idx] ? 'ca. ' : '') + 'side ' + (o.groups[first.idx] + 1)));
        a.addEventListener('click', function () { self.go(self.offsets().groups[first.idx]); });
        li.appendChild(a);
        var sub = el('ul', 'nbk-toc-page__parts');
        d.groups.forEach(function (g) {
          var sli = el('li'), sb = el('button', 'nbk-toc-page__part');
          sb.type = 'button';
          sb.appendChild(el('span', null, g.title));
          sb.appendChild(el('span', 'nbk-toc-page__no', String(o.groups[g.idx] + 1)));
          sb.addEventListener('click', function () { self.go(self.offsets().groups[g.idx]); });
          sli.appendChild(sb);
          sub.appendChild(sli);
        });
        li.appendChild(sub);
        list.appendChild(li);
      });
    } else this.groups.forEach(function (g) {
      var li = el('li');
      var a = el('button', 'nbk-toc-page__item');
      a.type = 'button';
      var ic = el('span', 'nbk-toc-page__picto'); ic.innerHTML = self.picto(g.picto);
      a.appendChild(ic);
      var txt = el('span', 'nbk-toc-page__text');
      txt.appendChild(el('span', 'nbk-toc-page__name', g.title));
      txt.appendChild(el('span', 'nbk-toc-page__count', fmtInt(self.groupCount(g)) + ' varer' + (g.parts.length > 1 ? ' · ' + g.parts.length + ' afsnit' : '')));
      a.appendChild(txt);
      a.appendChild(el('span', 'nbk-toc-page__no', (o.approx[g.idx] ? 'ca. ' : '') + 'side ' + (o.groups[g.idx] + 1)));
      a.addEventListener('click', function () { self.go(self.offsets().groups[g.idx]); });
      li.appendChild(a);
      if (g.parts.length > 1) {
        var sub = el('ul', 'nbk-toc-page__parts');
        g.parts.forEach(function (p) {
          var sli = el('li'), sb = el('button', 'nbk-toc-page__part');
          sb.type = 'button';
          sb.appendChild(el('span', null, p.title));
          sb.appendChild(el('span', 'nbk-toc-page__no', String(o.parts[p.idx] + 1)));
          sb.addEventListener('click', function () { self.go(self.offsets().parts[p.idx]); });
          sli.appendChild(sb);
          sub.appendChild(sli);
        });
        li.appendChild(sub);
      }
      list.appendChild(li);
    });
    body.appendChild(list);
    page.appendChild(body);
    var foot = el('div', 'nbk-foot');
    foot.appendChild(el('span', 'nbk-foot__no', String(index + 1)));
    page.appendChild(foot);
    return page;
  };

  // Products in a chapter: the loaded sections' own count, the webshop's count for the rest
  Book.prototype.groupCount = function (g) {
    return g.parts.reduce(function (s, p) { return s + (p.items ? p.items.length : p.count); }, 0);
  };
  Book.prototype.deptCount = function (d) {
    var self = this;
    return d.groups.reduce(function (s, g) { return s + self.groupCount(g); }, 0);
  };


  // A chapter's opening page: its sections with page numbers, or (one section) its brands
  Book.prototype.renderOpener = function (body, grp) {
    var self = this, o = this.offsets();
    body.classList.add('nbk-body--opener');
    var ic = el('div', 'nbk-opener__picto'); ic.innerHTML = this.picto(grp.picto);
    body.appendChild(ic);
    body.appendChild(el('p', 'nbk-opener__eyebrow', this.front ? 'Kapitel ' + (grp.idx + 1) : (this.cfg.eyebrow || 'Katalog')));
    body.appendChild(el('p', 'nbk-opener__title', grp.title));
    if (grp.intro) body.appendChild(el('p', 'nbk-opener__intro', grp.intro));
    var multi = grp.parts.length > 1, ch = grp.parts[0];
    var loaded = grp.parts.every(function (p) { return p.items; });
    var countText = fmtInt(this.groupCount(grp)) + (this.shelfOnly && loaded ? ' varer på hylden i butikken' : ' varer');
    if (multi) countText += ' · ' + grp.parts.length + ' afsnit';
    else if (ch.brands) countText += ' · ' + ch.brands.length + ' ' + plural(ch.brands.length, 'mærke', 'mærker');
    body.appendChild(el('p', 'nbk-opener__count', countText));
    if (multi) {
      var parts = el('ul', 'nbk-opener__parts');
      parts.setAttribute('aria-label', 'Afsnit i kapitlet');
      grp.parts.forEach(function (p) {
        var li = el('li'), btn = el('button', 'nbk-opener__part');
        btn.type = 'button';
        var t = el('span', 'nbk-opener__part-text');
        t.appendChild(el('span', 'nbk-opener__part-name', p.title));
        t.appendChild(el('span', 'nbk-opener__part-count', fmtInt(p.items ? p.items.length : p.count) + ' varer' + (p.brands ? ' · ' + p.brands.length + ' ' + plural(p.brands.length, 'mærke', 'mærker') : '')));
        btn.appendChild(t);
        btn.appendChild(el('span', 'nbk-opener__brand-no', (self.paginate(p).estimated ? 'ca. ' : '') + 'side ' + (o.parts[p.idx] + 1)));
        btn.addEventListener('click', function () { self.go(self.offsets().parts[p.idx]); });
        li.appendChild(btn);
        parts.appendChild(li);
      });
      body.appendChild(parts);
    } else if (!this.paginate(ch).estimated && ch.brands) {
      var list = el('ul', 'nbk-opener__brands');
      list.setAttribute('aria-label', 'Mærker i kapitlet');
      ch.brands.forEach(function (b) {
        var li = el('li');
        var btn = el('button', 'nbk-opener__brand');
        btn.type = 'button';
        btn.appendChild(el('span', null, b.name));
        btn.appendChild(el('span', 'nbk-opener__brand-no', String(o.parts[ch.idx] + b.page + 1)));
        btn.addEventListener('click', function () { self.go(self.offsets().parts[ch.idx] + b.page); });
        li.appendChild(btn);
        list.appendChild(li);
      });
      body.appendChild(list);
    } else {
      var msg = el('div', 'nbk-loading');
      msg.appendChild(el('p', null, ch.failed ? 'Kapitlet kunne ikke hentes.' : 'Henter mærker og varer …'));
      var bar = el('div', 'nbk-progress'); var fill = el('span');
      fill.style.transform = 'scaleX(' + (ch.progress || 0.04) + ')';
      bar.appendChild(fill); msg.appendChild(bar);
      body.appendChild(msg);
      this.load(ch);
    }
    var href = grp.url || (multi ? null : ch.url);
    if (href) {
      var link = el('a', 'nbk-opener__link', 'Se kapitlet i webshoppen →');
      link.href = href;
      body.appendChild(link);
    }
  };


  // One catalogue entry: photo, name and the start of the description, then a table with a row per
  // variant (item number, variant, price, a small basket button that puts it in the basket)
  Book.prototype.renderEntry = function (item) {
    var self = this;
    var art = el('article', 'nbk-entry' + (item.multi ? ' nbk-entry--multi' : '') + (item.single ? ' nbk-entry--single' : '') + (item.a ? '' : ' nbk-entry--out'));
    art.style.height = item.ht + 'px';
    art.dataset.h = item.h;
    var head = el('button', 'nbk-entry__head');
    head.type = 'button';
    head.setAttribute('aria-label', item.t + (item.brand && !item.other ? ', ' + item.brand : '') + ' – se varen');
    var media = el('span', 'nbk-entry__media');
    var main = null;
    if (item.i) {
      main = el('img');
      main.src = item.i; main.alt = ''; main.decoding = 'async'; // only the pages in view are drawn, so no lazy loading
      media.appendChild(main);
    }
    head.appendChild(media);
    var text = el('span', 'nbk-entry__text');
    text.appendChild(el('span', 'nbk-entry__title', item.t));
    if (item.f) text.appendChild(el('span', 'nbk-entry__facts', item.f));
    head.appendChild(text);
    head.addEventListener('click', function () { self.openProduct(item); });
    art.appendChild(head);

    var table = this.variantTable(item, item.rows, main);
    var tbody = table.tBodies[0];
    if (item.more > 0) {
      var mtr = el('tr', 'nbk-vt__more'), mtd = el('td');
      mtd.colSpan = 5;
      var mb = el('button', 'nbk-vt__more-btn');
      mb.type = 'button';
      if (this.collapse && item.rows.length) {
        // Unfold the whole list over the page; the page itself keeps its layout
        var all = item.rows.length + item.more;
        mb.classList.add('nbk-vt__more-btn--fold');
        mb.setAttribute('aria-expanded', 'false');
        mb.appendChild(el('span', null, 'Vis alle ' + all + ' varianter'));
        mb.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 20 20" width="12" height="12" aria-hidden="true"><path d="M5 8l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        mb.addEventListener('click', function () { self.unfold(item, art, mb, main); });
      } else {
        mb.textContent = item.rows.length ? '+ ' + item.more + ' ' + plural(item.more, 'variant', 'varianter') + ' mere' : 'Vælg variant';
        mb.addEventListener('click', function () { self.openProduct(item); });
      }
      mtd.appendChild(mb);
      mtr.appendChild(mtd);
      tbody.appendChild(mtr);
    }
    if (main) table.addEventListener('pointerleave', function () { main.src = item.i; });
    art.appendChild(table);
    return art;
  };

  // The variant table: a head row on products with variants, then one row per variant
  Book.prototype.variantTable = function (item, rows, main) {
    var self = this;
    var table = el('table', 'nbk-vt');
    if (item.multi) {
      var thead = el('thead'), htr = el('tr');
      var thDot = el('th'); thDot.appendChild(el('span', 'visually-hidden', 'På hylden'));
      htr.appendChild(thDot);
      htr.appendChild(el('th', 'nbk-vt__sku', 'Varenr.'));
      htr.appendChild(el('th', 'nbk-vt__var', !item.o || /^title$/i.test(item.o) ? 'Variant' : item.o));
      htr.appendChild(el('th', 'nbk-vt__price', 'Pris'));
      var thBuy = el('th'); thBuy.appendChild(el('span', 'visually-hidden', 'Køb'));
      htr.appendChild(thBuy);
      thead.appendChild(htr);
      table.appendChild(thead);
    }
    var tbody = el('tbody');
    rows.forEach(function (v) {
      var tr = el('tr', 'nbk-vt__row' + (v.sh ? ' is-shelf' : ''));
      var dot = el('td', 'nbk-vt__shelf');
      if (v.sh) { var d = el('span', 'nbk-dot'); d.title = 'På hylden i butikken'; dot.appendChild(d); dot.appendChild(el('span', 'visually-hidden', 'På hylden i butikken')); }
      tr.appendChild(dot);
      tr.appendChild(el('td', 'nbk-vt__sku', v.s || ''));
      var vc = el('td', 'nbk-vt__var');
      var name = el('button', 'nbk-vt__name');
      name.type = 'button';
      if (item.thumbs && v.i) { var th = el('img', 'nbk-vt__thumb'); th.src = v.i; th.alt = ''; name.appendChild(th); }
      var label = item.multi ? v.t : (v.sh ? 'På hylden' : '');
      name.appendChild(el('span', 'nbk-vt__label', label));
      name.setAttribute('aria-label', item.t + (item.multi ? ', ' + v.t : '') + ' – se varen');
      name.addEventListener('click', function () { self.closePanel(); self.openProduct(item, v.id); });
      vc.appendChild(name);
      tr.appendChild(vc);
      var pc = el('td', 'nbk-vt__price');
      if (v.c > v.p) { var was = el('s', 'nbk-price__was', formatPrice(v.c)); was.setAttribute('aria-label', 'Normalpris ' + formatPrice(v.c)); pc.appendChild(was); }
      pc.appendChild(el('span', v.c > v.p ? 'nbk-price__now nbk-price__now--sale' : 'nbk-price__now', formatPrice(v.p)));
      tr.appendChild(pc);
      var bc = el('td', 'nbk-vt__buy');
      if (v.a) {
        var buy = el('button', 'nbk-buy');
        buy.type = 'button';
        buy.innerHTML = '<svg viewBox="0 0 20 20" width="15" height="15" aria-hidden="true"><path d="M2 3h2.2l1.9 9.2a1.5 1.5 0 0 0 1.5 1.2h6.9a1.5 1.5 0 0 0 1.5-1.1L17.5 7H5.3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="17" r="1.5" fill="currentColor"/><circle cx="14.5" cy="17" r="1.5" fill="currentColor"/></svg>';
        buy.setAttribute('aria-label', 'Læg ' + item.t + (item.multi ? ', ' + v.t : '') + ' i kurven');
        buy.addEventListener('click', function () { self.addToCart(v.id, 1, buy); });
        bc.appendChild(buy);
      } else {
        bc.appendChild(el('span', 'nbk-vt__out', 'Udsolgt'));
      }
      tr.appendChild(bc);
      // The variant's own photo in the entry while the row is pointed at
      if (main && v.i) {
        var show = function () { main.src = v.i; };
        tr.addEventListener('pointerenter', show);
        tr.addEventListener('focusin', show);
      }
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    return table;
  };

  // "Vis alle n varianter": the full list unfolds over the page from the entry, scrolls if it is long,
  // and folds away again with "Skjul", Escape, a click outside or a page turn
  Book.prototype.unfold = function (item, art, toggle, main) {
    var self = this;
    if (this.panel && this.panel.toggle === toggle) { this.closePanel(true); return; }
    this.closePanel();
    var col = art.parentNode, body = col.parentNode, table = art.querySelector('.nbk-vt');
    var panel = el('div', 'nbk-fold');
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Alle varianter af ' + item.t);
    var head = el('div', 'nbk-fold__head');
    head.appendChild(el('span', 'nbk-fold__title', 'Alle ' + (item.rows.length + item.more) + ' varianter'));
    var close = el('button', 'nbk-fold__close');
    close.type = 'button';
    close.innerHTML = '<span>Skjul</span><svg viewBox="0 0 20 20" width="12" height="12" aria-hidden="true"><path d="M5 12l5-5 5 5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    close.addEventListener('click', function () { self.closePanel(true); });
    head.appendChild(close);
    panel.appendChild(head);
    var scroller = el('div', 'nbk-fold__body');
    var rows = this.shelfOnly ? item.vsShown.filter(function (v) { return v.sh; }) : item.vsShown;
    scroller.appendChild(this.variantTable(item, rows, main));
    panel.appendChild(scroller);
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); self.closePanel(true); }
    });
    body.appendChild(panel);

    // Over the entry's table (photo and name stay in view), at least 400px wide so the variant names
    // fit in a narrow column, moved up if it would run past the page; the list scrolls inside
    function place() {
      // Screen sizes divided by the zoom give sizes inside the zoomed page content
      var z = self.zoom || 1;
      var b = body.getBoundingClientRect(), c = col.getBoundingClientRect(), t = table.getBoundingClientRect();
      var bodyW = b.width / z, bodyH = b.height / z;
      var width = Math.min(bodyW, Math.max(c.width / z, 400));
      panel.style.width = width + 'px';
      panel.style.left = Math.max(0, Math.min((c.left - b.left) / z, bodyW - width)) + 'px';
      var need = panel.scrollHeight;
      var top = Math.max(0, Math.min((t.top - b.top) / z - 6, bodyH - need));
      panel.style.top = top + 'px';
      panel.style.maxHeight = (bodyH - top) + 'px';
    }
    place();
    this.panel = { el: panel, toggle: toggle };
    toggle.setAttribute('aria-expanded', 'true');
    close.focus();

    // Variants past the first 12 come from the product itself (without shelf marks)
    var have = (item.vs || []).length;
    if (!this.shelfOnly && item.n > have) {
      fetch('/products/' + encodeURIComponent(item.h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
        if (!self.panel || self.panel.el !== panel) return;
        var known = {};
        (item.vs || []).forEach(function (v) { known[v.id] = v; });
        var full = (p.variants || []).filter(function (v) { return self.showSoldOut || v.available; }).map(function (v) {
          return known[v.id] || { id: v.id, s: v.sku, t: v.title, p: v.price, c: v.compare_at_price || 0, a: v.available, sh: false, i: v.featured_image ? v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=200' : null };
        });
        scroller.replaceChildren(self.variantTable(item, full, main));
        place();
      }).catch(function () {});
    }
    // A click anywhere else folds it away
    this.panelOutside = function (e) { if (self.panel && !panel.contains(e.target) && e.target !== toggle && !toggle.contains(e.target) && !self.dialog.contains(e.target)) self.closePanel(); };
    setTimeout(function () { document.addEventListener('click', self.panelOutside); }, 0);
  };

  Book.prototype.closePanel = function (refocus) {
    if (!this.panel) return;
    var p = this.panel;
    this.panel = null;
    document.removeEventListener('click', this.panelOutside);
    p.toggle.setAttribute('aria-expanded', 'false');
    if (p.el.parentNode) p.el.remove();
    if (refocus && p.toggle.isConnected) p.toggle.focus();
  };

  // Which pages are visible for a given first index
  Book.prototype.view = function (first) {
    if (this.mode !== 'spread') return [first];
    if (first <= 0) return [-1, 0];
    var left = first % 2 === 1 ? first : first - 1;
    return [left, left + 1];
  };
  Book.prototype.normalise = function (index) {
    var total = this.total();
    index = Math.max(0, Math.min(total - 1, index));
    if (this.mode === 'spread' && index > 0 && index % 2 === 0) index -= 1;
    return index;
  };

  Book.prototype.show = function (keepFocus) {
    this.closePanel();
    var v = this.view(this.cur);
    var l = this.mode === 'spread' ? this.renderPage(v[0]) : null;
    var r = this.renderPage(this.mode === 'spread' ? v[1] : v[0]);
    this.slotL.replaceChildren();
    this.slotR.replaceChildren();
    if (l) this.slotL.appendChild(l);
    this.slotR.appendChild(r);
    this.book.classList.toggle('nbk-book--cover', this.cur === 0);
    this.updateLabel();
    this.remember();
    if (this.pendingFind) this.markFound();
  };

  /* ---------- Thumb index: chapter tabs on the book's outer edge ---------- */
  // One tab per chapter, the one being read in navy. Pointing at a tab (or focusing it) shows the chapter
  // with its sections and brands and their page numbers beside it; a click jumps there. Not on phones (CSS).
  // With groups of chapters (this.depts) the tabs fold in two (owner, 31 Oct 2026): one tab per group, and
  // under the group being read its chapters as narrower tabs. A group's tab shows its chapters beside it.
  function railLabel(title) { return title.split(/[,&]| og /)[0].trim() || title; }

  Book.prototype.buildRail = function () {
    var self = this, rail = this.rail;
    if (!rail) return;
    rail.replaceChildren();
    var tabs = el('div', 'nbk-rail__tabs');
    function chapterTab(g, extra) {
      var b = el('button', 'nbk-rail__tab' + (extra ? ' ' + extra : ''));
      b.type = 'button';
      // The first word on the tab ("Ankering", "Komfort"); the full name is in the flyout
      b.appendChild(el('span', 'nbk-rail__label', railLabel(g.title)));
      // The chapter number, shown instead of the name when a group's names don't fit (see fitRail)
      b.appendChild(el('span', 'nbk-rail__num', String(g.idx + 1)));
      b.setAttribute('aria-label', g.title + ' – gå til kapitlet');
      b.addEventListener('click', function () { self.closeFly(); self.go(self.offsets().groups[g.idx]); });
      b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.openFly(g.idx, b, true); });
      b.addEventListener('focus', function () { self.openFly(g.idx, b, false); });
      return b;
    }
    this.railTabs = [];
    this.railDepts = [];
    if (this.depts) {
      tabs.classList.add('nbk-rail__tabs--folded');
      this.depts.forEach(function (d) {
        var db = el('button', 'nbk-rail__tab nbk-rail__tab--dept');
        db.type = 'button';
        db.appendChild(el('span', 'nbk-rail__label', railLabel(d.title)));
        db.setAttribute('aria-label', d.title + ' – gå til første kapitel');
        db.setAttribute('aria-expanded', 'false');
        db.addEventListener('click', function () { self.closeFly(); self.go(self.offsets().groups[d.groups[0].idx]); });
        db.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.openDeptFly(d, db); });
        db.addEventListener('focus', function () { self.openDeptFly(d, db); });
        tabs.appendChild(db);
        self.railDepts.push(db);
        var sub = el('div', 'nbk-rail__sub');
        sub.hidden = true;
        d.groups.forEach(function (g) {
          var b = chapterTab(g, 'nbk-rail__tab--sub');
          self.railTabs[g.idx] = b;
          sub.appendChild(b);
        });
        d.sub = sub;
        tabs.appendChild(sub);
      });
    } else {
      this.groups.forEach(function (g) {
        var b = chapterTab(g);
        self.railTabs[g.idx] = b;
        tabs.appendChild(b);
      });
    }
    rail.appendChild(tabs);
    this.fly = el('div', 'nbk-fly');
    this.fly.hidden = true;
    rail.appendChild(this.fly);
    rail.addEventListener('pointerleave', function () { self.flyTimer = setTimeout(function () { self.closeFly(); }, 250); });
    rail.addEventListener('pointerenter', function () { clearTimeout(self.flyTimer); });
    rail.addEventListener('focusout', function (e) { if (!rail.contains(e.relatedTarget)) self.closeFly(); });
    rail.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || self.fly.hidden) return;
      e.preventDefault(); e.stopPropagation();
      var t = self.flyTab;
      self.closeFly();
      if (t) t.focus();
    });
  };

  // Marks the tab whose flyout is open
  Book.prototype.markFlyTab = function (tab) {
    this.flyTab = tab;
    this.railTabs.concat(this.railDepts || []).forEach(function (t) { t.classList.toggle('is-open', t === tab); });
  };

  // Beside the tab, within the book's height
  Book.prototype.placeFly = function (tab, scroll) {
    var fly = this.fly, bookH = this.book.clientHeight;
    fly.hidden = false;
    fly.style.top = '0px';
    var top = tab.getBoundingClientRect().top - this.rail.getBoundingClientRect().top;
    fly.style.top = Math.max(0, Math.min(top - 8, bookH - fly.offsetHeight)) + 'px';
    fly.scrollTop = scroll;
  };

  // The flyout of a group's tab: the group, then its chapters with their page numbers
  Book.prototype.openDeptFly = function (d, tab) {
    var self = this, fly = this.fly;
    clearTimeout(this.flyTimer);
    clearTimeout(this.flyLoad);
    this.flyIdx = -1;
    this.markFlyTab(tab);
    fly.replaceChildren();
    var o = this.offsets(), first = d.groups[0];
    var head = el('button', 'nbk-fly__chapter');
    head.type = 'button';
    var pic = el('span', 'nbk-fly__picto');
    pic.innerHTML = this.picto(d.picto);
    head.appendChild(pic);
    head.appendChild(el('span', 'nbk-fly__name', d.title));
    head.appendChild(el('span', 'nbk-fly__no', (o.approx[first.idx] ? 'ca. ' : '') + 'side ' + (o.groups[first.idx] + 1)));
    head.addEventListener('click', function () { self.closeFly(); self.go(self.offsets().groups[first.idx]); });
    fly.appendChild(head);
    fly.appendChild(el('p', 'nbk-fly__count', fmtInt(this.deptCount(d)) + ' varer · ' + d.groups.length + ' ' + plural(d.groups.length, 'kapitel', 'kapitler')));
    d.groups.forEach(function (g) {
      var sec = el('div', 'nbk-fly__part');
      var pb = el('button', 'nbk-fly__part-btn');
      pb.type = 'button';
      pb.appendChild(el('span', 'nbk-fly__part-name', g.title));
      pb.appendChild(el('span', 'nbk-fly__no', (o.approx[g.idx] ? 'ca. ' : '') + 'side ' + (o.groups[g.idx] + 1)));
      pb.addEventListener('click', function () { self.closeFly(); self.go(self.offsets().groups[g.idx]); });
      sec.appendChild(pb);
      fly.appendChild(sec);
    });
    this.placeFly(tab, 0);
  };


  // The flyout of a chapter tab: the chapter, then its sections (each with its brands once loaded), or
  // for a chapter of one section its brands
  Book.prototype.openFly = function (i, tab, hover) {
    var self = this, g = this.groups[i], fly = this.fly;
    clearTimeout(this.flyTimer);
    clearTimeout(this.flyLoad);
    var scroll = fly.hidden || this.flyIdx !== i ? 0 : fly.scrollTop;
    this.flyIdx = i;
    this.markFlyTab(tab);
    fly.replaceChildren();
    var o = this.offsets(), multi = g.parts.length > 1;
    var head = el('button', 'nbk-fly__chapter');
    head.type = 'button';
    var pic = el('span', 'nbk-fly__picto');
    pic.innerHTML = this.picto(g.picto);
    head.appendChild(pic);
    head.appendChild(el('span', 'nbk-fly__name', g.title));
    head.appendChild(el('span', 'nbk-fly__no', (o.approx[g.idx] ? 'ca. ' : '') + 'side ' + (o.groups[g.idx] + 1)));
    head.addEventListener('click', function () { self.closeFly(); self.go(self.offsets().groups[i]); });
    fly.appendChild(head);
    var single = g.parts[0];
    fly.appendChild(el('p', 'nbk-fly__count', fmtInt(this.groupCount(g)) + ' varer' + (multi ? ' · ' + g.parts.length + ' afsnit' : (single.brands ? ' · ' + single.brands.length + ' ' + plural(single.brands.length, 'mærke', 'mærker') : ''))));
    function brandList(p, small) {
      var list = el('ul', 'nbk-fly__brands' + (small ? ' nbk-fly__brands--part' : ''));
      p.brands.forEach(function (b) {
        var li = el('li'), btn = el('button', 'nbk-fly__brand');
        btn.type = 'button';
        btn.appendChild(el('span', null, b.name));
        btn.appendChild(el('span', 'nbk-fly__no', String(o.parts[p.idx] + b.page + 1)));
        btn.addEventListener('click', function () { self.closeFly(); self.go(self.offsets().parts[p.idx] + b.page); });
        li.appendChild(btn);
        list.appendChild(li);
      });
      return list;
    }
    if (multi) {
      g.parts.forEach(function (p) {
        var sec = el('div', 'nbk-fly__part');
        var pb = el('button', 'nbk-fly__part-btn');
        pb.type = 'button';
        pb.appendChild(el('span', 'nbk-fly__part-name', p.title));
        pb.appendChild(el('span', 'nbk-fly__no', (self.paginate(p).estimated ? 'ca. ' : '') + 'side ' + (o.parts[p.idx] + 1)));
        pb.addEventListener('click', function () { self.closeFly(); self.go(self.offsets().parts[p.idx]); });
        sec.appendChild(pb);
        if (p.brands && p.brands.length) sec.appendChild(brandList(p, true));
        else if (!p.items) {
          var more = el('button', 'nbk-fly__more', p.loading ? 'Henter mærker …' : 'Vis mærker');
          more.type = 'button';
          more.addEventListener('click', function () {
            more.textContent = 'Henter mærker …';
            var pr = self.load(p);
            if (pr) pr.then(function () { if (!fly.hidden && self.flyIdx === i) self.openFly(i, tab, false); });
          });
          sec.appendChild(more);
        }
        fly.appendChild(sec);
      });
    } else if (single.brands && single.brands.length) {
      fly.appendChild(brandList(single, false));
    } else {
      fly.appendChild(el('p', 'nbk-fly__wait', single.failed ? 'Mærkerne kunne ikke hentes.' : 'Henter mærker …'));
      // Load the chapter when the pointer stays a moment (not on a quick pass over the tabs)
      this.flyLoad = setTimeout(function () {
        var pr = self.load(single);
        if (pr) pr.then(function () { if (!fly.hidden && self.flyIdx === i) self.openFly(i, tab, false); });
      }, hover ? 400 : 0);
    }
    this.placeFly(tab, scroll);
  };


  Book.prototype.closeFly = function () {
    if (!this.fly || this.fly.hidden) return;
    clearTimeout(this.flyLoad);
    this.fly.hidden = true;
    this.flyIdx = null;
    this.markFlyTab(null);
  };

  // The tab of the chapter being read
  Book.prototype.updateRail = function () {
    if (!this.railTabs) return;
    var v = this.view(this.cur), self = this, current = -1;
    v.forEach(function (i) { var w = self.locate(i); if (w.group) current = w.group.idx; });
    this.railTabs.forEach(function (t, j) {
      t.classList.toggle('is-current', j === current);
      if (j === current) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    if (this.depts) {
      var cd = current >= 0 ? this.groups[current].deptRef : null;
      this.depts.forEach(function (d, k) {
        var on = d === cd, t = self.railDepts[k];
        t.classList.toggle('is-current', on);
        t.setAttribute('aria-expanded', String(on));
        d.sub.hidden = !on;
      });
      this.fitRail();
    }
  };

  // An unfolded group shows its chapters' names when they all fit beside the book, else their numbers
  // (like a printed thumb index); the name is in the flyout either way
  Book.prototype.fitRail = function () {
    if (!this.depts) return;
    this.depts.forEach(function (d) {
      if (d.sub.hidden) return;
      d.sub.classList.remove('nbk-rail__sub--num');
      var cut = Array.prototype.some.call(d.sub.querySelectorAll('.nbk-rail__label'), function (l) { return l.scrollHeight > l.clientHeight + 1; });
      d.sub.classList.toggle('nbk-rail__sub--num', cut);
    });
  };


  // The reader's zoom (toolbar slider): bigger or smaller page content, pages laid out again
  Book.prototype.setZoom = function (z) {
    this.userZoom = Math.max(0.8, Math.min(1.6, z));
    try { localStorage.setItem('nbk-zoom', String(this.userZoom)); } catch (e) {}
    this.remember();
    this.measure();
    this.relayout();
  };

  Book.prototype.updateLabel = function () {
    var o = this.offsets(), v = this.view(this.cur), total = o.total;
    var shown = v.filter(function (i) { return i >= 0 && i < total; }).map(function (i) { return i + 1; });
    var onCover = this.front && this.cur === 0;
    this.updateRail();
    var text = onCover ? 'Forside' : 'Side ' + shown.join('–');
    var of = ' / ' + (o.exact ? '' : 'ca. ') + fmtInt(total);
    this.label.textContent = text + (onCover ? '' : of);
    this.live.textContent = text + ' af ' + (o.exact ? '' : 'cirka ') + fmtInt(total);
    var atStart = this.cur <= 0, atEnd = v[v.length - 1] >= total - 1;
    this.root.querySelectorAll('[data-nbk-prev],[data-nbk-first]').forEach(function (b) { b.disabled = atStart; });
    this.root.querySelectorAll('[data-nbk-next],[data-nbk-last]').forEach(function (b) { b.disabled = atEnd; });
  };

  /* ---------- Navigation ---------- */
  Book.prototype.go = function (index, opts) {
    opts = opts || {};
    var target = this.normalise(index);
    if (target === this.cur && !opts.instant) return;
    var dir = target > this.cur ? 1 : -1;
    var from = this.cur;
    this.cur = target;
    this.remember(); // a chapter that finishes loading mid-turn keeps this place
    if (opts.instant || reduceMotion.matches || Math.abs(target - from) > (this.mode === 'spread' ? 2 : 1)) {
      this.show();
      if (!opts.instant && reduceMotion.matches) {
        this.book.animate([{ opacity: 0.4 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' });
      }
    } else {
      this.turn(from, target, dir);
    }
    if (!this.inOverlay && !opts.instant) {
      try { history.replaceState(null, '', target > 0 ? '#side-' + (target + 1) : location.pathname + location.search); } catch (e) {}
    }
    // Load the chapter being read, and the next one
    var where = this.locate(this.view(target).slice(-1)[0]);
    var part = where.chapter || (where.group && where.group.parts[0]);
    if (part) {
      this.load(part);
      var nextPart = this.chapters[part.idx + 1];
      if (nextPart && part.items) this.load(nextPart);
    }
  };

  Book.prototype.next = function () { this.go(this.mode === 'spread' ? (this.cur === 0 ? 1 : this.cur + 2) : this.cur + 1); };
  Book.prototype.prev = function () { this.go(this.mode === 'spread' ? this.cur - 2 : this.cur - 1); };

  // The page turn: a sheet with the old page on its front and the new page on its back folds over the spine
  Book.prototype.turn = function (from, to, dir) {
    if (this.animating) { this.animating.finish(); }
    this.closePanel();
    this.closeFly();
    var spread = this.mode === 'spread';
    var vFrom = this.view(from), vTo = this.view(to);
    var sheet = el('div', 'nbk-sheet ' + (dir > 0 ? 'nbk-sheet--next' : 'nbk-sheet--prev'));
    var front = el('div', 'nbk-sheet__face nbk-sheet__face--front');
    var back = el('div', 'nbk-sheet__face nbk-sheet__face--back');
    var shade = el('div', 'nbk-sheet__shade');
    if (spread) {
      if (dir > 0) {
        front.appendChild(this.renderPage(vFrom[1]));
        back.appendChild(this.renderPage(vTo[0]));
        this.slotR.replaceChildren(this.renderPage(vTo[1]));
      } else {
        front.appendChild(this.renderPage(vFrom[0]));
        back.appendChild(this.renderPage(vTo[1]));
        this.slotL.replaceChildren(this.renderPage(vTo[0]));
      }
    } else {
      if (dir > 0) {
        front.appendChild(this.renderPage(vFrom[0]));
        this.slotR.replaceChildren(this.renderPage(vTo[0]));
      } else {
        back.appendChild(el('div', 'nbk-page nbk-page--blank'));
        front.appendChild(this.renderPage(vTo[0]));
      }
    }
    sheet.appendChild(front); sheet.appendChild(back); sheet.appendChild(shade);
    this.book.appendChild(sheet);
    this.book.classList.toggle('nbk-book--cover', to === 0);
    var single = !spread;
    var frames, origin;
    if (single && dir < 0) {
      // Back on a phone: the previous page comes in from the left over the current one
      frames = [{ transform: 'rotateY(-180deg)' }, { transform: 'rotateY(0deg)' }];
    } else {
      frames = dir > 0 ? [{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(-180deg)' }] : [{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(180deg)' }];
    }
    var self = this;
    var anim = sheet.animate(frames, { duration: single ? 480 : 620, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', fill: 'forwards' });
    shade.animate([{ opacity: 0 }, { opacity: 0.5, offset: 0.5 }, { opacity: 0 }], { duration: single ? 480 : 620, easing: 'linear' });
    this.animating = anim;
    anim.onfinish = function () {
      self.animating = null;
      sheet.remove();
      self.show();
    };
    this.updateLabel();
  };

  // Redraw if the section is on screen (its pages, its chapter's opening page or the contents page)
  Book.prototype.refreshIfShowing = function (ch, progressOnly) {
    var v = this.view(this.cur), self = this;
    var showing = v.some(function (i) { return self.shows(self.locate(i), ch); });
    if (!showing) return;
    if (progressOnly) {
      this.root.querySelectorAll('.nbk-progress > span').forEach(function (s) { s.style.transform = 'scaleX(' + (ch.progress || 0.04) + ')'; });
      return;
    }
    this.show();
  };
  Book.prototype.shows = function (w, ch) {
    return w.chapter === ch || (w.kind === 'opener' && w.group === ch.group) || w.kind === 'toc';
  };


  // Keep the reader's place when pages are re-laid out (a section finished loading, the window changed
  // size, the shelf filter or the zoom changed): the place number of the first product on the page
  Book.prototype.remember = function () {
    // Of the pages in view, one in a loaded section if there is one (an estimated page number moves
    // when the sections before it load)
    var self = this, shown = this.view(this.cur).filter(function (i) { return i > 0; });
    // A chapter's first page in view wins: a jump to a chapter (tab, contents) shows it beside the last
    // page of the chapter before, and anchoring to that page drifted back into the previous chapter as
    // the estimated page numbers firmed up (owner, 31 Oct 2026)
    var openers = shown.filter(function (i) { return self.locate(i).kind === 'opener'; });
    if (openers.length) { this.anchor = { group: this.locate(openers[0]).group.idx }; return; }
    var loaded = shown.filter(function (i) { var w = self.locate(i); return w.kind === 'part' && w.chapter.pages && w.chapter.pages.list; });
    var where = this.locate(loaded[0] != null ? loaded[0] : (shown[0] || this.cur));
    var ch = where.chapter;
    if (where.kind === 'part' && ch.pages && ch.pages.list) {
      var spec = ch.pages.list[where.local];
      this.anchor = { part: ch.idx, ord: spec && spec.firstItem != null ? ch.items[spec.firstItem].ord : null, local: where.local };
    } else if (where.kind === 'part') {
      this.anchor = { part: ch.idx, ord: null, local: where.local };
    } else if (where.kind === 'opener') {
      this.anchor = { group: where.group.idx };
    } else {
      this.anchor = { front: this.cur };
    }
  };


  // changed: the section that just loaded. If it is not on screen and the place stays, only the page
  // count changes, so an unfolded variant list stays open.
  Book.prototype.relayout = function (changed) {
    if (this.animating) this.animating.finish();
    var a = this.anchor;
    var o = this.offsets();
    var target = this.cur;
    if (a && a.part != null) {
      var ch = this.chapters[a.part];
      var pg = this.paginate(ch);
      var local = 0;
      if (pg.list && a.ord != null) {
        for (var i = 0; i < pg.list.length; i++) {
          var f = pg.list[i].firstItem;
          if (f != null && ch.items[f].ord <= a.ord) local = i;
        }
      } else if (pg.list && a.local > 0) {
        local = Math.min(a.local, pg.list.length - 1);
      }
      target = o.parts[a.part] + local;
    } else if (a && a.group != null) {
      target = o.groups[a.group];
    } else if (a && a.front != null) {
      target = a.front;
    }
    target = this.normalise(target);
    var self = this;
    if (changed && target === this.cur && !this.view(target).some(function (i) { return self.shows(self.locate(i), changed); })) {
      this.updateLabel();
      return;
    }
    this.cur = target;
    this.show();
  };


  // The filters: "Kun på hylden" (only products on the shelf in the shop, and only those variants) and
  // "Vis udsolgte" (sold-out products and variants too). The loaded sections are sorted again.
  Book.prototype.setFilters = function (shelfOnly, showSoldOut) {
    // Several switches in a row without turning a page keep the place of the first one, so going back and
    // forth between the filters does not creep backwards through the section page by page
    if (this.filterPlace && this.filterPlace.cur === this.cur) this.anchor = this.filterPlace.anchor;
    else this.remember();
    var place = this.anchor;
    this.shelfOnly = shelfOnly;
    this.showSoldOut = showSoldOut;
    var self = this;
    this.chapters.forEach(function (c) {
      if (c.raw) c.items = self.prepare(c.raw);
      c.pages = null;
      c.brands = null;
    });
    this.ui.classList.toggle('nbk--shelf', shelfOnly);
    this.ui.classList.toggle('nbk--filtered', shelfOnly || showSoldOut !== !!this.cfg.showSoldOut);
    this.relayout();
    this.filterPlace = { anchor: place, cur: this.cur };
    this.live.textContent = shelfOnly ? 'Viser kun varer på hylden i butikken' : (showSoldOut ? 'Viser også udsolgte varer' : 'Viser alle varer, der kan købes');
  };

  Book.prototype.pageFromHash = function () {
    if (this.inOverlay) return null;
    var m = /#side-(\d+)/.exec(location.hash);
    return m ? Math.max(0, parseInt(m[1], 10) - 1) : null;
  };

  /* ---------- Contents panel, search, full screen ---------- */
  Book.prototype.renderTocPanel = function () {
    var o = this.offsets(), self = this;
    // Everything but the filters, which sit at the top of the panel on phones
    Array.prototype.slice.call(this.toc.children).forEach(function (n) { if (!n.matches('[data-nbk-filters]')) n.remove(); });
    var list = el('ol', 'nbk-toc__list');
    var front = el('li');
    var fb = el('button', 'nbk-toc__item', 'Forside'); fb.type = 'button';
    fb.addEventListener('click', function () { self.closeToc(); self.go(0); });
    if (this.front) { front.appendChild(fb); list.appendChild(front); }
    function brands(p, into) {
      if (!p.brands || !p.brands.length) return;
      var sub = el('ul', 'nbk-toc__brands');
      p.brands.forEach(function (br) {
        var sli = el('li');
        var sb = el('button', 'nbk-toc__brand'); sb.type = 'button';
        sb.appendChild(el('span', null, br.name));
        sb.appendChild(el('span', 'nbk-toc__no', String(o.parts[p.idx] + br.page + 1)));
        sb.addEventListener('click', function () { self.closeToc(); self.go(self.offsets().parts[p.idx] + br.page); });
        sli.appendChild(sb); sub.appendChild(sli);
      });
      into.appendChild(sub);
    }
    this.groups.forEach(function (g) {
      if (self.depts && g.deptRef.groups[0] === g) list.appendChild(el('li', 'nbk-toc__dept', g.dept));
      var li = el('li');
      var b = el('button', 'nbk-toc__item'); b.type = 'button';
      var ic = el('span', 'nbk-toc__picto'); ic.innerHTML = self.picto(g.picto);
      b.appendChild(ic);
      b.appendChild(el('span', 'nbk-toc__name', g.title));
      b.appendChild(el('span', 'nbk-toc__no', String(o.groups[g.idx] + 1)));
      b.addEventListener('click', function () { self.closeToc(); self.go(self.offsets().groups[g.idx]); });
      li.appendChild(b);
      if (g.parts.length > 1) {
        var parts = el('ul', 'nbk-toc__parts');
        g.parts.forEach(function (p) {
          var pli = el('li');
          var pb = el('button', 'nbk-toc__part'); pb.type = 'button';
          pb.appendChild(el('span', null, p.title));
          pb.appendChild(el('span', 'nbk-toc__no', String(o.parts[p.idx] + 1)));
          pb.addEventListener('click', function () { self.closeToc(); self.go(self.offsets().parts[p.idx]); });
          pli.appendChild(pb);
          brands(p, pli);
          parts.appendChild(pli);
        });
        li.appendChild(parts);
      } else {
        brands(g.parts[0], li);
      }
      list.appendChild(li);
    });
    this.toc.appendChild(list);
  };

  Book.prototype.openToc = function () {
    this.renderTocPanel();
    this.toc.hidden = false;
    this.root.querySelector('[data-nbk-toc-toggle]').setAttribute('aria-expanded', 'true');
    var first = this.toc.querySelector('button');
    if (first) first.focus();
  };
  Book.prototype.closeToc = function () {
    if (this.toc.hidden) return;
    this.toc.hidden = true;
    var t = this.root.querySelector('[data-nbk-toc-toggle]');
    t.setAttribute('aria-expanded', 'false');
  };

  Book.prototype.search = function (q) {
    var box = this.root.querySelector('[data-nbk-results]');
    var self = this;
    if (q.length < 2) { box.hidden = true; box.replaceChildren(); return; }
    var url = ((window.routes && window.routes.predictiveSearchUrl) || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    var token = (this.searchToken = (this.searchToken || 0) + 1);
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (data) {
      if (token !== self.searchToken) return;
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      box.replaceChildren();
      if (!products.length) {
        box.appendChild(el('p', 'nbk-search__empty', 'Ingen varer fundet. Prøv et varenummer eller et mærke.'));
      }
      var list = el('ul', 'nbk-search__list');
      products.forEach(function (p) {
        var li = el('li');
        var b = el('button', 'nbk-search__item'); b.type = 'button';
        if (p.image || (p.featured_image && p.featured_image.url)) {
          var img = el('img'); img.src = p.image || p.featured_image.url; img.alt = ''; img.loading = 'lazy';
          b.appendChild(img);
        }
        var t = el('span', 'nbk-search__text');
        t.appendChild(el('span', 'nbk-search__title', p.title));
        if (p.vendor) t.appendChild(el('span', 'nbk-search__vendor', p.vendor));
        b.appendChild(t);
        var cents = Math.round(parseFloat(p.price || 0) * (String(p.price).indexOf('.') > -1 ? 100 : 1));
        if (p.price != null) b.appendChild(el('span', 'nbk-search__price', formatPrice(cents)));
        b.addEventListener('click', function () {
          box.hidden = true;
          self.findProduct(p.handle, { h: p.handle, t: p.title, b: p.vendor, i: p.image || null, a: p.available !== false });
        });
        li.appendChild(b); list.appendChild(li);
      });
      box.appendChild(list);
      var all = el('a', 'nbk-search__all', 'Vis alle resultater i webshoppen →');
      all.href = '/search?type=product&q=' + encodeURIComponent(q);
      box.appendChild(all);
      box.hidden = false;
    }).catch(function () {});
  };

  Book.prototype.fullscreen = function () {
    var target = this.ui;
    if (document.fullscreenElement) { document.exitFullscreen(); return; }
    if (target.requestFullscreen) target.requestFullscreen().catch(function () {});
  };

  /* ---------- Product popup ---------- */
  Book.prototype.openProduct = function (item, variantId) {
    var self = this, body = this.dialogBody;
    body.replaceChildren();
    var titleId = body.getAttribute('data-title-id');
    var wrap = el('div', 'nbk-product');
    var gallery = el('div', 'nbk-product__gallery');
    var main = el('img', 'nbk-product__image');
    main.alt = item.t || '';
    if (item.i) main.src = item.i;
    gallery.appendChild(main);
    var thumbs = el('div', 'nbk-product__thumbs');
    gallery.appendChild(thumbs);
    wrap.appendChild(gallery);
    var info = el('div', 'nbk-product__info');
    if (item.b) info.appendChild(el('p', 'nbk-product__vendor', item.b));
    var h = el('h3', 'nbk-product__title', item.t || '');
    h.id = titleId;
    info.appendChild(h);
    var sku = el('p', 'nbk-product__sku', item.s ? 'Varenr. ' + item.s : '');
    info.appendChild(sku);
    var price = el('p', 'nbk-product__price');
    info.appendChild(price);
    var stock = el('p', 'nbk-product__stock');
    info.appendChild(stock);
    var form = el('form', 'nbk-product__form');
    form.noValidate = true; // the browser's own warning would be in the browser's language; the amount is corrected instead
    var variantWrap = el('div', 'nbk-product__variant');
    form.appendChild(variantWrap);
    var qty = el('div', 'nbk-qty');
    var minus = el('button', 'nbk-qty__btn', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Færre');
    var input = el('input', 'nbk-qty__input'); input.type = 'number'; input.min = '1'; input.value = '1'; input.inputMode = 'numeric'; input.setAttribute('aria-label', 'Antal');
    var plus = el('button', 'nbk-qty__btn', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Flere');
    minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);
    form.appendChild(qty);
    var add = el('button', 'nbk-btn nbk-btn--primary nbk-product__add', 'Læg i kurv');
    add.type = 'submit';
    form.appendChild(add);
    info.appendChild(form);
    var desc = el('div', 'nbk-product__desc');
    info.appendChild(desc);
    var link = el('a', 'nbk-product__link', 'Se hele varen →');
    link.href = '/products/' + item.h;
    info.appendChild(link);
    wrap.appendChild(info);
    body.appendChild(wrap);

    var variants = [], current = null;
    function setVariant(v) {
      current = v;
      if (!v) return;
      sku.textContent = v.sku ? 'Varenr. ' + v.sku : '';
      price.replaceChildren();
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      price.appendChild(el('span', onSale ? 'nbk-price__now nbk-price__now--sale' : 'nbk-price__now', formatPrice(v.price)));
      if (onSale) price.appendChild(el('s', 'nbk-price__was', formatPrice(v.compare_at_price)));
      var known = (item.vs || []).filter(function (x) { return x.id === v.id; })[0];
      var onShelf = known ? known.sh : (item.vs ? false : item.sh);
      stock.className = 'nbk-product__stock nbk-stock' + (!v.available ? ' nbk-stock--out' : (onShelf ? ' nbk-stock--shelf' : ''));
      stock.textContent = !v.available ? 'Udsolgt' : (onShelf ? 'På hylden i butikken på Skovshoved Havn' : 'Kan bestilles');
      add.disabled = !v.available;
      add.textContent = v.available ? 'Læg i kurv' : 'Udsolgt';
      if (v.featured_image && v.featured_image.src) main.src = v.featured_image.src;
    }
    price.textContent = item.p != null ? (item.v ? 'Fra ' : '') + formatPrice(item.p) : '';
    add.disabled = true;

    fetch('/products/' + encodeURIComponent(item.h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      h.textContent = p.title;
      main.alt = p.title;
      if (p.vendor && !info.querySelector('.nbk-product__vendor')) info.insertBefore(el('p', 'nbk-product__vendor', p.vendor), h);
      var imgs = (p.images || []).slice(0, 8);
      if (imgs[0]) main.src = imgs[0] + (imgs[0].indexOf('?') > -1 ? '&' : '?') + 'width=800';
      if (imgs.length > 1) {
        imgs.forEach(function (src, i) {
          var tb = el('button', 'nbk-product__thumb'); tb.type = 'button';
          tb.setAttribute('aria-label', 'Billede ' + (i + 1));
          var ti = el('img'); ti.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; ti.alt = '';
          tb.appendChild(ti);
          tb.addEventListener('click', function () { main.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800'; });
          thumbs.appendChild(tb);
        });
      }
      variants = p.variants || [];
      if (variants.length > 1) {
        var label = el('label', 'nbk-product__variant-label', (p.options && p.options.length === 1 ? p.options[0].name || p.options[0] : 'Variant'));
        var sel = el('select', 'nbk-product__select');
        sel.id = titleId + '-variant';
        label.htmlFor = sel.id;
        variants.forEach(function (v) {
          var dv = (item.vs || []).filter(function (x) { return x.id === v.id; })[0];
          var o = el('option', null, v.title + (!v.available ? ' – udsolgt' : (dv && dv.sh ? ' – på hylden i butikken' : '')));
          o.value = v.id;
          sel.appendChild(o);
        });
        var first = variants.filter(function (v) { return String(v.id) === String(variantId); })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];
        sel.value = first.id;
        sel.addEventListener('change', function () { setVariant(variants.filter(function (v) { return String(v.id) === sel.value; })[0]); });
        variantWrap.appendChild(label); variantWrap.appendChild(sel);
        setVariant(first);
      } else {
        setVariant(variants[0]);
      }
      desc.innerHTML = cleanHtml(p.description);
    }).catch(function () {
      desc.appendChild(el('p', null, 'Varen kunne ikke hentes. Prøv at åbne den i webshoppen.'));
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current) return;
      input.value = Math.max(1, parseInt(input.value, 10) || 1);
      self.addToCart(current.id, parseInt(input.value, 10), add, true);
    });

    if (!this.dialog.open) {
      if (this.dialog.showModal) this.dialog.showModal(); else this.dialog.setAttribute('open', '');
    }
  };

  Book.prototype.closeDialog = function () {
    if (this.dialog.open) { if (this.dialog.close) this.dialog.close(); else this.dialog.removeAttribute('open'); }
  };

  Book.prototype.addToCart = function (variantId, quantity, button, fromDialog) {
    var self = this;
    if (!variantId || (button && button.getAttribute('aria-busy') === 'true')) return;
    if (button) button.setAttribute('aria-busy', 'true');
    var addUrl = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity })
    }).then(function (r) {
      if (button) button.removeAttribute('aria-busy');
      if (!r.ok) { self.say('Varen kunne ikke lægges i kurven.'); return; }
      if (fromDialog) self.closeDialog();
      if (self.ownCart()) {
        // In the popup or in full screen the shop's basket panel can't be seen: update the basket,
        // say so here and offer the book's own basket panel
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        self.say('Lagt i kurven.', true);
        if (self.cartPanel && !self.cartPanel.hidden) self.openCart(); else self.updateCartCount();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: quantity, productAdded: false } }));
      }
      if (button && !fromDialog) {
        button.classList.add('is-added');
        setTimeout(function () { button.classList.remove('is-added'); }, 1400);
      }
    }).catch(function () {
      if (button) button.removeAttribute('aria-busy');
      self.say('Varen kunne ikke lægges i kurven.');
    });
  };

  Book.prototype.say = function (text, withCartLink) {
    var t = this.toast;
    t.replaceChildren(el('span', null, text));
    if (withCartLink) {
      var a = el('button', 'nbk-toast__link', 'Se kurven');
      a.type = 'button';
      var self = this;
      a.addEventListener('click', function () { t.hidden = true; self.openCart(); });
      t.appendChild(a);
    }
    t.hidden = false;
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () { t.hidden = true; }, 3500);
  };

  /* ---------- The book's own basket panel (popup and full screen) ---------- */
  Book.prototype.ownCart = function () {
    return this.inOverlay || document.fullscreenElement === this.ui;
  };

  Book.prototype.cartUrl = function (path) { return ((window.routes && window.routes.cartUrl) || '/cart') + path; };

  Book.prototype.updateCartCount = function (cart) {
    var badge = this.root.querySelector('[data-nbk-cart-count]');
    if (!badge) return;
    var set = function (c) { badge.textContent = String(c.item_count); badge.hidden = !c.item_count; };
    if (cart) { set(cart); return; }
    fetch(this.cartUrl('.js'), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(set).catch(function () {});
  };

  Book.prototype.openCart = function () {
    var self = this, panel = this.cartPanel;
    if (!panel) return;
    panel.hidden = false;
    this.cartToggle.setAttribute('aria-expanded', 'true');
    if (!panel.contains(document.activeElement)) panel.querySelector('[data-nbk-cart-close]').focus();
    fetch(this.cartUrl('.js'), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) { self.renderCart(cart); }).catch(function () {
      self.cartBody.replaceChildren(el('p', 'nbk-cart__empty', 'Kurven kunne ikke hentes.'));
    });
  };

  Book.prototype.closeCart = function (refocus) {
    if (!this.cartPanel || this.cartPanel.hidden) return;
    this.cartPanel.hidden = true;
    this.cartToggle.setAttribute('aria-expanded', 'false');
    if (refocus) this.cartToggle.focus();
  };

  Book.prototype.renderCart = function (cart) {
    var self = this, body = this.cartBody, foot = this.cartFoot;
    this.updateCartCount(cart);
    body.replaceChildren();
    foot.replaceChildren();
    if (!cart.items || !cart.items.length) {
      body.appendChild(el('p', 'nbk-cart__empty', 'Kurven er tom.'));
      foot.hidden = true;
      return;
    }
    var list = el('ul', 'nbk-cart__list');
    cart.items.forEach(function (it) {
      var li = el('li', 'nbk-cart__item');
      var media = el('span', 'nbk-cart__media');
      if (it.image) { var img = el('img'); img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; img.alt = ''; media.appendChild(img); }
      li.appendChild(media);
      var info = el('div', 'nbk-cart__info');
      var name = el('a', 'nbk-cart__name', it.product_title);
      name.href = it.url;
      info.appendChild(name);
      if (it.variant_title && !/^default title$/i.test(it.variant_title)) info.appendChild(el('span', 'nbk-cart__variant', it.variant_title));
      if (it.sku) info.appendChild(el('span', 'nbk-cart__variant', 'Varenr. ' + it.sku));
      var row = el('div', 'nbk-cart__row');
      var qty = el('div', 'nbk-qty nbk-qty--small');
      var minus = el('button', 'nbk-qty__btn', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Færre af ' + it.product_title);
      var n = el('span', 'nbk-qty__value', String(it.quantity));
      var plus = el('button', 'nbk-qty__btn', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Flere af ' + it.product_title);
      minus.addEventListener('click', function () { self.changeCart(it.key, it.quantity - 1); });
      plus.addEventListener('click', function () { self.changeCart(it.key, it.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(n); qty.appendChild(plus);
      row.appendChild(qty);
      row.appendChild(el('span', 'nbk-cart__price', formatPrice(it.final_line_price)));
      info.appendChild(row);
      var remove = el('button', 'nbk-cart__remove', 'Fjern');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Fjern ' + it.product_title + ' fra kurven');
      remove.addEventListener('click', function () { self.changeCart(it.key, 0); });
      info.appendChild(remove);
      li.appendChild(info);
      list.appendChild(li);
    });
    body.appendChild(list);
    var total = el('p', 'nbk-cart__total');
    total.appendChild(el('span', null, 'I alt'));
    total.appendChild(el('strong', null, formatPrice(cart.total_price)));
    foot.appendChild(total);
    var checkout = el('a', 'nbk-btn nbk-btn--primary', 'Til kassen');
    checkout.href = '/checkout';
    foot.appendChild(checkout);
    var all = el('a', 'nbk-cart__all', 'Se hele kurven');
    all.href = this.cartUrl('');
    foot.appendChild(all);
    foot.hidden = false;
  };

  Book.prototype.changeCart = function (key, quantity) {
    var self = this;
    this.cartBody.setAttribute('aria-busy', 'true');
    fetch(this.cartUrl('/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); }).then(function (res) {
      self.cartBody.removeAttribute('aria-busy');
      if (!res.ok) {
        // e.g. no more in stock: Shopify's own message, and the basket as it is
        self.say(res.data && (res.data.description || res.data.message) || 'Kurven kunne ikke opdateres.');
        self.openCart();
        return;
      }
      self.renderCart(res.data);
      // The button that was pressed may be gone with its line: keep the focus in the panel
      if (!self.cartPanel.contains(document.activeElement)) self.cartPanel.querySelector('[data-nbk-cart-close]').focus();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      self.cartBody.removeAttribute('aria-busy');
      self.say('Kurven kunne ikke opdateres.');
    });
  };

  /* ---------- From a search hit to its page ---------- */
  // Where a product stands in the loaded sections: {part, local page}
  Book.prototype.locateProduct = function (handle, only) {
    var parts = only ? [only] : this.chapters;
    for (var k = 0; k < parts.length; k++) {
      var p = parts[k];
      if (!p.items) continue;
      var idx = -1;
      for (var i = 0; i < p.items.length; i++) { if (p.items[i].h === handle) { idx = i; break; } }
      if (idx < 0) continue;
      var pg = this.paginate(p);
      for (var l = 0; l < pg.list.length; l++) {
        var hit = pg.list[l].cols.some(function (c) { return c.some(function (b) { return b.item === idx; }); });
        if (hit) return { part: p, local: l };
      }
    }
    return null;
  };

  // A search hit: turn to the page with the product and mark it. If its section isn't loaded, ask the
  // shop which collections it is in (templates/product.katalogcol.liquid) and load that section first.
  // Products that are not in the book open in the product popup.
  Book.prototype.findProduct = function (handle, fallback) {
    var self = this;
    var hit = this.locateProduct(handle);
    if (hit) { this.showFound(hit, handle); return; }
    fetch('/products/' + encodeURIComponent(handle) + '?view=katalogcol', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
      var a = t.indexOf('/*NBKATALOG*/'), b = t.lastIndexOf('/*NBKATALOG*/');
      var cols = a > -1 && b > a ? (JSON.parse(t.slice(a + 13, b)).c || []) : [];
      var part = self.chapters.filter(function (p) { return cols.indexOf(p.handle) > -1; })[0];
      if (!part) { self.openProduct(fallback); return; }
      if (!part.items) self.say('Finder varen i kataloget …');
      return Promise.resolve(self.load(part)).then(function () {
        var found = self.locateProduct(handle, part);
        if (found) self.showFound(found, handle); else self.openProduct(fallback);
      });
    }).catch(function () { self.openProduct(fallback); });
  };

  Book.prototype.showFound = function (hit, handle) {
    var target = this.normalise(this.offsets().parts[hit.part.idx] + hit.local);
    this.pendingFind = handle;
    if (target === this.cur) this.markFound();
    else this.go(target);
  };

  // After the page is drawn: the found product lights up and gets the focus
  Book.prototype.markFound = function () {
    var handle = this.pendingFind;
    this.pendingFind = null;
    if (!handle) return;
    var entry = null;
    this.book.querySelectorAll('.nbk-slot .nbk-entry').forEach(function (e) { if (e.dataset.h === handle) entry = e; });
    if (!entry) return;
    entry.classList.remove('is-found');
    void entry.offsetWidth;
    entry.classList.add('is-found');
    setTimeout(function () { entry.classList.remove('is-found'); }, 2600);
    var head = entry.querySelector('.nbk-entry__head');
    if (head) head.focus({ preventScroll: true });
  };

  /* ---------- Events ---------- */
  Book.prototype.bind = function () {
    var self = this, root = this.root;
    root.querySelectorAll('[data-nbk-next]').forEach(function (b) { b.addEventListener('click', function () { self.next(); }); });
    root.querySelectorAll('[data-nbk-prev]').forEach(function (b) { b.addEventListener('click', function () { self.prev(); }); });
    root.querySelector('[data-nbk-first]').addEventListener('click', function () { self.go(0); });
    root.querySelector('[data-nbk-last]').addEventListener('click', function () { self.go(self.total() - 1); });
    root.querySelector('[data-nbk-toc-toggle]').addEventListener('click', function () { if (self.toc.hidden) self.openToc(); else self.closeToc(); });
    root.querySelector('[data-nbk-fullscreen]').addEventListener('click', function () { self.fullscreen(); });
    // Search from the upright toolbar: the field opens beside it
    var searchToggle = root.querySelector('[data-nbk-search-toggle]'), searchForm = root.querySelector('[data-nbk-search]');
    var setSearch = function (open, refocus) {
      self.ui.classList.toggle('nbk--search-open', open);
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) searchForm.querySelector('input[type="search"]').focus();
      else if (refocus) searchToggle.focus();
    };
    if (searchToggle && searchForm) {
      searchToggle.addEventListener('click', function () { setSearch(!self.ui.classList.contains('nbk--search-open')); });
      searchForm.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.ui.classList.contains('nbk--search-open')) { e.preventDefault(); e.stopPropagation(); setSearch(false, true); }
      });
      document.addEventListener('click', function (e) {
        if (self.ui.classList.contains('nbk--search-open') && e.target.isConnected && !searchForm.contains(e.target) && !searchToggle.contains(e.target)) setSearch(false);
      });
      // A chosen hit closes the field
      searchForm.addEventListener('click', function (e) { if (e.target.closest('.nbk-search__item')) setSearch(false); });
    }

    var zoom = root.querySelector('[data-nbk-zoom-range]'), zt;
    root.querySelectorAll('[data-nbk-zoom-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var z = Math.round((self.userZoom + 0.1 * parseInt(b.getAttribute('data-nbk-zoom-step'), 10)) * 10) / 10;
        if (zoom) zoom.value = Math.round(Math.max(0.8, Math.min(1.6, z)) * 100);
        self.setZoom(z);
      });
    });
    if (zoom) {
      zoom.value = Math.round(this.userZoom * 100);
      zoom.addEventListener('input', function () {
        var vz = root.querySelector('[data-nbk-zoom-value]');
        if (vz) vz.textContent = zoom.value + ' %';
        clearTimeout(zt);
        zt = setTimeout(function () { self.setZoom(zoom.value / 100); }, 150);
      });
    }
    this.cartPanel = root.querySelector('[data-nbk-cart]');
    this.cartBody = root.querySelector('[data-nbk-cart-body]');
    this.cartFoot = root.querySelector('[data-nbk-cart-foot]');
    this.cartToggle = root.querySelector('[data-nbk-cart-open]');
    if (this.cartPanel && this.cartToggle) {
      this.cartToggle.addEventListener('click', function () { if (self.cartPanel.hidden) self.openCart(); else self.closeCart(true); });
      root.querySelector('[data-nbk-cart-close]').addEventListener('click', function () { self.closeCart(true); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.cartPanel.hidden && !self.dialog.open && !e.defaultPrevented) { e.preventDefault(); e.stopPropagation(); self.closeCart(true); }
      }, true);
      document.addEventListener('click', function (e) {
        // (a click on + or − redraws the list, so its target may already be gone)
        if (!e.target.isConnected) return;
        if (!self.cartPanel.hidden && !self.cartPanel.contains(e.target) && !self.cartToggle.contains(e.target) && !e.target.closest('.nbk-toast')) self.closeCart(false);
      });
      if (this.inOverlay) this.updateCartCount();
    }
    var shelf = root.querySelector('[data-nbk-shelf]'), soldout = root.querySelector('[data-nbk-soldout]');
    if (soldout) soldout.checked = this.showSoldOut;
    var refilter = function () { self.setFilters(shelf ? shelf.checked : false, soldout ? soldout.checked : self.showSoldOut); };
    if (shelf) shelf.addEventListener('change', refilter);
    if (soldout) soldout.addEventListener('change', refilter);
    root.querySelector('[data-nbk-dialog-close]').addEventListener('click', function () { self.closeDialog(); });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.closeDialog(); });

    var form = root.querySelector('[data-nbk-search]');
    var input = form.querySelector('input[type="search"]');
    var timer;
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { self.search(input.value.trim()); }, 220); });
    form.addEventListener('submit', function (e) {
      // Enter opens the first hit; without hits it goes to the webshop's search page
      var first = form.querySelector('.nbk-search__item');
      if (first) { e.preventDefault(); first.click(); }
    });
    document.addEventListener('click', function (e) {
      var box = form.querySelector('[data-nbk-results]');
      if (!box.hidden && !form.contains(e.target)) box.hidden = true;
      if (!self.toc.hidden && !self.toc.contains(e.target) && !e.target.closest('[data-nbk-toc-toggle]')) self.closeToc();
    });

    // Keys: arrows turn pages (not while typing or in the popup)
    (this.inOverlay ? root : document).addEventListener('keydown', function (e) {
      if (self.dialog.open || self.panel) return;
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'SELECT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      if (!self.inOverlay && !root.isConnected) return;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); self.next(); }
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); self.prev(); }
      else if (e.key === 'Home' && e.altKey) { e.preventDefault(); self.go(0); }
      else if (e.key === 'Escape' && !self.toc.hidden) { e.preventDefault(); self.closeToc(); root.querySelector('[data-nbk-toc-toggle]').focus(); }
    });

    // Swipe on touch screens; a tap on the outer page edge also turns the page
    var sx = null, sy = null, st = 0;
    this.stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; sx = e.clientX; sy = e.clientY; st = Date.now(); });
    this.stage.addEventListener('pointerup', function (e) {
      if (sx == null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy, dt = Math.max(1, Date.now() - st);
      sx = null;
      if (Math.abs(dx) > Math.abs(dy) * 1.4 && (Math.abs(dx) > 50 || Math.abs(dx) / dt > 0.4)) {
        if (dx < 0) self.next(); else self.prev();
      }
    });
    this.stage.addEventListener('pointercancel', function () { sx = null; });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var oldMode = self.mode, oldRows = self.rows, oldCols = self.cols, oldH = self.pageH;
        self.remember();
        self.measure();
        if (oldMode !== self.mode || oldRows !== self.rows || oldCols !== self.cols || Math.abs(oldH - self.pageH) > 4) self.relayout();
      }, 180);
    });
    document.addEventListener('fullscreenchange', function () {
      if (document.fullscreenElement === self.ui) self.updateCartCount(); else self.closeCart(false);
      setTimeout(function () { self.remember(); self.measure(); self.relayout(); }, 120);
    });
  };

  function readConfig(root) {
    var node = root.querySelector('script[data-nbk-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  // The popup on collection pages: a full-screen layer over the page with the book inside
  function openOverlay(overlay, opener) {
    var root = overlay.querySelector('[data-nb-katalog]');
    // Out of the section, so no parent's stacking or overflow can clip the layer
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    overlay.hidden = false;
    document.documentElement.classList.add('nbk-lock');
    var book = root.__nbk;
    if (book) { book.remember(); book.measure(); book.relayout(); }
    else book = window.NBKatalog.mount(root);
    var close = overlay.querySelector('[data-nbk-close]');
    if (close) close.focus();
    if (overlay.__nbkBound) { overlay.__nbkOpener = opener; return book; }
    overlay.__nbkBound = true;
    overlay.__nbkOpener = opener;
    function shut() {
      if (overlay.hidden) return;
      if (document.fullscreenElement) document.exitFullscreen().catch(function () {});
      overlay.hidden = true;
      document.documentElement.classList.remove('nbk-lock');
      if (overlay.__nbkOpener) overlay.__nbkOpener.focus();
    }
    if (close) close.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (overlay.hidden || e.key !== 'Escape' || e.defaultPrevented || root.__nbk.dialog.open || !root.__nbk.toc.hidden) return;
      var box = overlay.querySelector('[data-nbk-results]');
      if (box && !box.hidden) { box.hidden = true; return; }
      shut();
    });
    // Keep keyboard focus inside the layer while it is open
    document.addEventListener('focusin', function (e) {
      if (!overlay.hidden && !overlay.contains(e.target) && close) close.focus();
    });
    return book;
  }

  window.NBKatalog = {
    mount: function (root, config) {
      if (root.__nbk) return root.__nbk;
      config = config || readConfig(root);
      if (!config) return null;
      root.__nbk = new Book(root, config);
      return root.__nbk;
    },
    openOverlay: openOverlay
  };

  function auto() {
    document.querySelectorAll('[data-nb-katalog]:not([data-nbk-lazy])').forEach(function (root) { window.NBKatalog.mount(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();
})();
